import { css } from '@emotion/react';

export const xexymixCss = css`
  /* font */
  @import url('https://fonts.googleapis.com/css?family=Montserrat:400,500,700,800');
  @import url('https://fonts.googleapis.com/css?family=Noto+Sans+KR:100,300,400,500,700,900&display=swap&subset=korean');

  @charset "euc-kr";
  #m_preview_wrap {
    display: none !important;
  } /* 미리보기 숨기기 */
  .wrapper {
    overflow: hidden;
  }
  .ani2 {
    -webkit-transition: all 200ms ease;
    -moz-transition: all 200ms ease;
    -ms-transition: all 200ms ease;
    -o-transition: all 200ms ease;
    transition: all 200ms ease;
  }
  .ani3 {
    -webkit-transition: all 300ms ease;
    -moz-transition: all 300ms ease;
    -ms-transition: all 300ms ease;
    -o-transition: all 300ms ease;
    transition: all 300ms ease;
  }
  .ani5 {
    -webkit-transition: all 500ms ease;
    -moz-transition: all 500ms ease;
    -ms-transition: all 500ms ease;
    -o-transition: all 500ms ease;
    transition: all 500ms ease;
  }

  body.notscroll {
    overflow: hidden;
  }
  body.scroll {
    overflow: auto;
  }

  /* base */
  * {
    -webkit-text-size-adjust: none;
  }
  body {
    position: relative;
    font-size: 0.813em;
    line-height: 1.188em;
    color: #111;
    -webkit-font-smoothing: antialiased;
    -webkit-text-size-adjust: 100%;
  }
  body,
  input,
  textarea,
  select,
  button,
  table {
    font:
      0.75em 'Montserrat',
      'Noto Sans KR',
      sans-serif;
  }
  body,
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  ul,
  ol,
  li,
  dl,
  dt,
  dd,
  table,
  th,
  td,
  form,
  fieldset,
  legend,
  input,
  textarea,
  button,
  select,
  figure {
    margin: 0;
    padding: 0;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: normal;
    font-size: 100%;
    word-break: break-all;
  }
  ul,
  ol,
  li {
    list-style: none;
  }
  fieldset,
  img {
    border: none;
  }
  img {
    max-width: 100%;
    vertical-align: top;
  }
  hr,
  button img {
    display: none;
  }
  form,
  fieldset,
  legend,
  label {
    margin: 0;
    padding: 0;
  }
  fieldset {
    border: 0 none;
  }
  fieldset legend {
    position: absolute;
    visibility: hidden;
    overflow: hidden;
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    font: 0/0 Arial;
  }
  em,
  address {
    font-style: normal;
  }
  input,
  textarea,
  select,
  button,
  table {
    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
    color: #111;
  }
  label {
    cursor: pointer;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    background: url('https://www.xexymix.com/design/xexymix/renewal/mobile/img/common/select_bg.jpg') no-repeat center
      right;
    background-size: 21px auto;
  }
  a {
    color: black;
    text-decoration: none;
  }

  input[type='checkbox'],
  input[type='radio'] {
    -webkit-appearance: button;
    color: #000;
    white-space: nowrap;
    overflow: hidden;
    width: 17px;
    height: 17px;
    margin-right: 2px;
    margin-bottom: 1px;
    border-radius: 0px !important;
    background-image: url('https://www.xexymix.comhttps://www.xexymix.com/design/xexymix/renewal/mobile/img/common/checkbox_off.jpg') !important;
    background-size: 100% !important;
    border: none !important;
    transition: none !important;
  }
  input[type='checkbox']:checked,
  input[type='radio']:checked {
    border-radius: 0px !important;
    color: #000 !important;
    background-image: url('https://www.xexymix.com/design/xexymix/renewal/mobile/img/common/checkbox_on.jpg') !important;
    background-position: center !important;
    background-size: 100% !important;
    border: none !important;
  }
  input[type='checkbox']:hover {
  }

  /*.priceicon{position: relative;
      margin-top: 5px; height:25px;}
  .prd-name{height:17px; overflow:hidden;}
  .prd-name-sub{height:28px; overflow: hidden;}*/

  /* //base */

  .bold {
    font-weight: bold;
  }
  .show {
    display: block !important;
  }
  .hide {
    display: none !important;
  }

  body.overlay,
  body.slider-overlay {
    overflow: hidden !important;
  }
  body:before {
    background: rgba(0, 0, 0, 0);
    content: '';
    transition: background 0.3s ease-in-out;
  }
  body.overlay.overlay_fadeout:before {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    z-index: 3000;
    background: rgba(0, 0, 0, 0);
    content: '';
    transition: background 0.3s ease-in-out;
  }
  body.overlay:before,
  body.slider-overlay:before {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    z-index: 3000;
    background: rgba(0, 0, 0, 0.5);
    content: '';
  }

  /* cross */
  * html input {
    margin: -1px 0;
  }
  *:first-child + html input {
    margin: -1px 0;
  }
  input.checkbox {
    width: 13px;
    height: 13px;
    margin-top: -4px;
    vertical-align: middle;
  }
  /* //cross */

  /* custom common */
  .no-scroll {
    overflow: hidden !important;
  }

  .left {
    float: left !important;
  }
  .right {
    float: right !important;
  }

  .text-left {
    text-align: left !important;
  }
  .text-center {
    text-align: center !important;
  }
  .text-right {
    text-align: right !important;
  }
  .text-bold {
    font-weight: bold !important;
  }

  .relative {
    position: relative;
  }

  .mt0 {
    margin-top: 0px !important;
  }
  .mt10 {
    margin-top: 10px !important;
  }
  .mt15 {
    margin-top: 15px !important;
  }
  .mt20 {
    margin-top: 20px !important;
  }
  .mt30 {
    margin-top: 30px !important;
  }
  .mt35 {
    margin-top: 35px !important;
  }
  .mt40 {
    margin-top: 40px !important;
  }
  .mt50 {
    margin-top: 50px !important;
  }
  .mt60 {
    margin-top: 60px !important;
  }
  .mt70 {
    margin-top: 70px !important;
  }
  .mt80 {
    margin-top: 80px !important;
  }
  .mt90 {
    margin-top: 90px !important;
  }
  .mt100 {
    margin-top: 100px !important;
  }

  .mr0 {
    margin-right: 0px !important;
  }
  .mr10 {
    margin-right: 10px !important;
  }
  .mr20 {
    margin-right: 20px !important;
  }
  .mr30 {
    margin-right: 30px !important;
  }
  .mr40 {
    margin-right: 40px !important;
  }
  .mr50 {
    margin-right: 50px !important;
  }
  .mr60 {
    margin-right: 60px !important;
  }
  .mr70 {
    margin-right: 70px !important;
  }
  .mr80 {
    margin-right: 80px !important;
  }
  .mr90 {
    margin-right: 90px !important;
  }
  .mr100 {
    margin-right: 100px !important;
  }

  .ml0 {
    margin-left: 0px !important;
  }
  .ml10 {
    margin-left: 10px !important;
  }
  .ml20 {
    margin-left: 20px !important;
  }
  .ml30 {
    margin-left: 30px !important;
  }
  .ml40 {
    margin-left: 40px !important;
  }
  .ml50 {
    margin-left: 50px !important;
  }
  .ml60 {
    margin-left: 60px !important;
  }
  .ml70 {
    margin-left: 70px !important;
  }
  .ml80 {
    margin-left: 80px !important;
  }
  .ml90 {
    margin-left: 90px !important;
  }
  .ml100 {
    margin-left: 100px !important;
  }

  .mb0 {
    margin-bottom: 0px !important;
  }
  .mb10 {
    margin-bottom: 10px !important;
  }
  .mb15 {
    margin-bottom: 15px !important;
  }
  .mb20 {
    margin-bottom: 20px !important;
  }
  .mb30 {
    margin-bottom: 30px !important;
  }
  .mb35 {
    margin-bottom: 35px !important;
  }
  .mb40 {
    margin-bottom: 40px !important;
  }
  .mb50 {
    margin-bottom: 50px !important;
  }
  .mb60 {
    margin-bottom: 60px !important;
  }
  .mb70 {
    margin-bottom: 70px !important;
  }
  .mb80 {
    margin-bottom: 80px !important;
  }
  .mb90 {
    margin-bottom: 90px !important;
  }
  .mb100 {
    margin-bottom: 100px !important;
  }

  .pt0 {
    padding-top: 0px !important;
  }
  .pt10 {
    padding-top: 10px !important;
  }
  .pt20 {
    padding-top: 20px !important;
  }
  .pt30 {
    padding-top: 30px !important;
  }
  .pt40 {
    padding-top: 40px !important;
  }
  .pt50 {
    padding-top: 50px !important;
  }
  .pt60 {
    padding-top: 60px !important;
  }
  .pt70 {
    padding-top: 70px !important;
  }
  .pt80 {
    padding-top: 80px !important;
  }
  .pt90 {
    padding-top: 90px !important;
  }
  .pt100 {
    padding-top: 100px !important;
  }

  .pr0 {
    padding-right: 0px !important;
  }
  .pr10 {
    padding-right: 10px !important;
  }
  .pr20 {
    padding-right: 20px !important;
  }
  .pr30 {
    padding-right: 30px !important;
  }
  .pr40 {
    padding-right: 40px !important;
  }
  .pr50 {
    padding-right: 50px !important;
  }
  .pr60 {
    padding-right: 60px !important;
  }
  .pr70 {
    padding-right: 70px !important;
  }
  .pr80 {
    padding-right: 80px !important;
  }
  .pr90 {
    padding-right: 90px !important;
  }
  .pr100 {
    padding-right: 100px !important;
  }

  .pl0 {
    padding-left: 0px !important;
  }
  .pl10 {
    padding-left: 10px !important;
  }
  .pl20 {
    padding-left: 20px !important;
  }
  .pl30 {
    padding-left: 30px !important;
  }
  .pl40 {
    padding-left: 40px !important;
  }
  .pl50 {
    padding-left: 50px !important;
  }
  .pl60 {
    padding-left: 60px !important;
  }
  .pl70 {
    padding-left: 70px !important;
  }
  .pl80 {
    padding-left: 80px !important;
  }
  .pl90 {
    padding-left: 90px !important;
  }
  .pl100 {
    padding-left: 100px !important;
  }

  .pb0 {
    padding-bottom: 0px !important;
  }
  .pb10 {
    padding-bottom: 10px !important;
  }
  .pb20 {
    padding-bottom: 20px !important;
  }
  .pb30 {
    padding-bottom: 30px !important;
  }
  .pb40 {
    padding-bottom: 40px !important;
  }
  .pb50 {
    padding-bottom: 50px !important;
  }
  .pb60 {
    padding-bottom: 60px !important;
  }
  .pb70 {
    padding-bottom: 70px !important;
  }
  .pb80 {
    padding-bottom: 80px !important;
  }
  .pb90 {
    padding-bottom: 90px !important;
  }
  .pb100 {
    padding-bottom: 100px !important;
  }

  #Hamburger {
    position: relative;
    z-index: 900;
  }
  #header-container .header-wrap {
    box-shadow: 0px 3px 5px rgb(0 0 0 / 5%);
  }

  #container .container_title {
    margin: 25px 0 20px;
    font-size: 22px;
    font-weight: 600;
    text-align: center;
  }

  /*상단탭메뉴*/
  .tab_menu {
    position: relative;
    width: 100%;
    background: #000;
    border-top: 1px solid #000;
    text-align: center;
    overflow: hidden;
  }
  .tab_menu a {
    position: relative;
    display: inline-block;
    width: calc(100% / 5);
    height: 34px;
    line-height: 34px;
    margin: -1.5px;
    color: #999999;
    font-size: 12px;
    vertical-align: top;
  }
  .tab_menu a.on {
    background: #fff;
    color: #000;
    border-radius: 8px 8px 0 0;
    font-weight: 600;
  }
  .tab_menu a.open::after {
    content: '';
    position: absolute;
    top: 10px;
    width: 6px;
    height: 6px;
    background: #ff6d44;
    border-radius: 50%;
    margin-left: 5%;
    /*-webkit-animation: blink 1.2s ease-in-out infinite alternate;
    -moz-animation: blink 1.2s ease-in-out infinite alternate;
    animation: blink 1.2s ease-in-out infinite alternate;*/
  }
  @-webkit-keyframes blink {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @-moz-keyframes blink {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes blink {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  /*커뮤니티메뉴탭*/
  #container .cs-tab {
    text-align: center;
    border-bottom: 1px solid #d2d2d2;
    border-top: 1px solid #d2d2d2;
  }
  #container .cs-tab ul:after {
    display: block;
    clear: both;
    content: '';
  }
  #container .cs-tab ul li {
    display: inline-block;
    box-sizing: border-box;
    margin: 0 2%;
  }
  #container .cs-tab ul li:first-child {
    border-left: none;
  }
  #container .cs-tab ul li a {
    display: inline-block;
    width: 100%;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    color: #999;
  }
  #container .cs-tab ul li a.active {
    border-bottom: 3px solid #000;
    color: #000;
  }
  #container .cs-tab ul li a img {
    width: auto;
    height: 100%;
  }

  /*마이페이지메뉴탭*/
  #container .mp_header {
    margin-top: 25px;
    color: #000;
    font-size: 22px;
    font-weight: 600;
    text-align: center;
  }
  #container .mp_navi {
    text-align: center;
    border-bottom: 1px solid #d2d2d2;
    border-top: 1px solid #d2d2d2;
  }
  #container .mp_navi ul:after {
    display: block;
    clear: both;
    content: '';
  }
  #container .mp_navi ul li {
    display: inline-block;
    box-sizing: border-box;
    margin: 0 2%;
  }
  #container .mp_navi ul li:first-child {
    border-left: none;
  }
  #container .mp_navi ul li a {
    display: inline-block;
    width: 100%;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    color: #999;
  }
  #container .mp_navi ul li a.active {
    border-bottom: 3px solid #000;
    color: #000;
  }
  #container .mp_navi ul li a img {
    width: auto;
    height: 100%;
  }

  #container .category-select {
    padding: 14px;
  }
  #container .category-select select {
    display: block;
    width: 100%;
    height: 40px;
    padding-left: 15px;
    border: 1px solid #ccc;
    color: #000;
    font-size: 14px;
  }

  #review-board-list .reviews {
    border-top: 1px solid #dadada !important;
  }
  #review-board-list .reviews > ul > li {
    padding: 15px !important;
    border-bottom: 1px solid #dadada !important;
  }
  #review-board-list .reviews > ul > li dl h4 {
    font-size: 13px !important;
    font-weight: normal !important;
    line-height: 25px !important;
  }
  #review-board-list .reviews > ul > li dl .info {
    margin-top: 5px !important;
    color: #888888 !important;
    font-size: 11px !important;
    font-weight: normal !important;
    line-height: 16px !important;
  }

  #container .paging-new {
    margin: 22px auto 25px 0px;
    padding: 0px;
  }
  #container .paging-new a {
    position: relative;
    width: 25px;
    height: 25px;
    margin: 0px 4px;
    border: none;
    background: none;
    font-weight: normal;
    color: #333333;
    font-size: 12px;
    line-height: 25px;
  }
  #container .paging-new a.now {
    color: #000;
    font-weight: bold;
  }
  #container .paging-new a.now:after {
    position: absolute;
    bottom: 0px;
    left: 50%;
    width: 8px;
    height: 1px;
    margin-left: -4px;
    background: #333;
    content: '';
  }
  #container .paging-new a.next:before {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 25px;
    height: 25px;
    line-height: 25px;
    content: '>';
    background: url(https://www.xexymix.com/design/xexymix/image/p_next.png) no-repeat center;
    background-size: 5px;
  }
  #container .paging-new a.prev:before {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 25px;
    height: 25px;
    line-height: 25px;
    content: '<';
    background: url(https://www.xexymix.com/design/xexymix/image/p_prev.png) no-repeat center;
    background-size: 5px;
  }
  #container .paging-new a.last:before {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 25px;
    height: 25px;
    line-height: 25px;
    content: '>>';
    background: url(https://www.xexymix.com/design/xexymix/image/p_last.png) no-repeat center;
    background-size: 9px;
  }
  #container .paging-new a.first:before {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 25px;
    height: 25px;
    line-height: 25px;
    content: '<<';
    background: url(https://www.xexymix.com/design/xexymix/image/p_first.png) no-repeat center;
    background-size: 9px;
  }

  .paging-new a.next,
  .paging-new a.prev,
  .paging-new a.first,
  .paging-new a.last {
    text-indent: -9999px !important;
  }

  #container #review-board-list .search-wrap {
    margin: 0px 14px;
    margin-bottom: 10px;
    padding: 0px;
    background: none;
  }
  #container #review-board-list .search-wrap form {
    display: block;
  }
  #container #review-board-list .search-wrap form fieldset {
    border: 1px solid #e1e1e1;
  }
  #container #review-board-list .search-wrap form fieldset:after {
    display: block;
    clear: both;
    content: '';
  }
  #container #review-board-list .search-wrap form fieldset label {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 10;
    width: 60px;
  }
  #container #review-board-list .search-wrap form fieldset label select {
    width: 100%;
    height: 38px;
    padding-left: 13px;
    border: none;
    color: #333333;
    font-size: 13px;
    box-sizing: border-box;
  }
  #container #review-board-list .search-wrap form fieldset .wrap {
    float: left;
    width: 100%;
    margin: 0px;
    padding: 0px;
  }
  #container #review-board-list .search-wrap form fieldset .wrap input {
    width: 100%;
    height: 38px;
    padding: 0px 48px 0px 73px;
    border: none;
    border-radius: none;
    color: #333333;
    font-size: 13px;
    box-sizing: border-box;
  }
  #container #review-board-list .search-wrap form fieldset a {
    width: 35px;
    height: 38px;
    margin: 0px;
    padding: 0px;
    border: none;
    background: url('https://www.xexymix.com/design/xexymix/renewal/mobile/img/common/cs_search_btn.jpg') no-repeat
      center center;
    background-size: auto 38px;
    text-indent: -999em;
    overflow: hidden;
  }

  #container #review-board-list .write-btn {
    margin: 0px 14px !important;
    margin-bottom: 45px !important;
    padding: 0px !important;
    background: none !important;
    border: none !important;
  }
  #container #review-board-list .write-btn a {
    display: inline-block;
    width: 100%;
    height: 40px;
    padding: 0px;
    margin: 0px;
    background: #000;
    border: none;
    border-radius: 0px !important;
    color: white;
    font-size: 14px;
    line-height: 40px;
    text-align: center;
  }
  #container #review-board-list .write-btn a strong {
    padding: 0px;
  }
  #container #review-board-list .notice-bar dt {
    font-size: 14px;
  }

  #review-board-list .reviews > ul > li dl .icon {
    display: inline-block;
    margin-top: 0px;
    margin-left: 5px;
  }

  #container #review-board-list .reviews > ul > li > dl h4,
  #container #review-board-type .reviews > ul > li > dl h4 {
    padding: 15px 10px;
    font-size: 15px;
  }

  #passimg {
    left: 0px !important;
    width: 100% !important;
  }
  #passimg .contents table {
    margin: 0 auto !important;
  }

  #review-board-list table.normal {
    background: none;
    border: 0;
  }
  #review-board-list table.normal tr {
    border: 0;
  }

  #review-board-list .form-wrap th {
    color: #333;
    text-indent: 14px;
    font-size: 13px;
    background: #fff;
    border: 0;
  }
  #review-board-list .form-wrap td {
    vertical-align: middle;
    text-indent: 0px;
    text-align: left;
    position: relative;
    padding: 5px 14px;
    border: 0;
  }
  #review-board-list .form-wrap .w100-wrap {
    padding-right: 0px;
    margin-right: 0;
  }
  #review-board-list .form-wrap input {
    vertical-align: middle;
    height: 40px;
    padding-right: 20px;
    padding-left: 5px;
    border-radius: 0;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #bbb;
    font-size: 13px;
  }
  #review-board-list .form-wrap td font {
    margin-top: 4px;
    font-size: 11px;
    display: inline-block;
  }
  #review-board-list .form-wrap textarea {
    height: 150px;
    padding: 5px 3px;
    box-sizing: border-box;
    border: 1px solid #bbb;
  }
  #review-board-list .form-wrap td .btns ul li {
    font-size: 0;
    margin-bottom: 4px;
  }
  #review-board-list .form-wrap td .btns input {
    width: 70%;
    margin-right: 2%;
  }
  #review-board-list .form-wrap td .btns a {
    width: 28%;
    height: 40px;
    line-height: 40px;
    font-size: 13px;
    color: #fff;
    border-radius: 0 !important;
    background-color: #858585;
    color: #fff;
    text-align: center;
    border: 1px solid #858585;
    box-sizing: border-box;
    vertical-align: middle;
  }

  /* 상품리스트 */
  .section {
    position: relative;
  }
  .section .section-title {
    margin-bottom: 15px;
    color: #000;
    font-size: 23px;
    text-align: left;
    padding-left: 4%;
    font-weight: 600;
    position: relative;
  }
  .section .section-desc {
    padding: 0 0 30px 20px;
    color: #000;
    opacity: 0.5;
  }
  .section .cols2 ul:after {
    display: block;
    clear: both;
    content: '';
  }
  .section .cols2 ul {
    margin-bottom: 35px;
    font-size: 0;
  }
  .section .cols2 ul:last-child {
    margin-bottom: 0px;
  }
  .section .cols2 ul:after {
    display: block;
    clear: both;
    content: '';
  }
  .section .cols2 .items li {
    width: 50%;
    vertical-align: top;
    box-sizing: border-box;
    text-align: left;
    display: inline-block;
    padding-bottom: 10%;
  }
  .section .cols2 .items li:nth-child(odd) {
    padding-right: 1%;
  }
  .section .cols2 .items li:nth-child(even) {
    padding-left: 1%;
  }
  .section .cols2 .items a {
    display: inline-block;
    width: 100%;
  }
  .section .cols2 .items a .img {
    margin-bottom: 5px;
    position: relative;
  }
  .section .cols2 .items a .img .no {
    position: absolute;
    color: #fff;
    background: #666;
    width: 28px;
    height: 28px;
    line-height: 28px;
    top: 0;
    right: 0;
    font-size: 13px;
    font-weight: 500;
    text-align: center;
  }
  .section .cols2 .items a .prd-info {
    padding: 0 5%;
  }
  .section .cols2 .items a .prd-name {
    font-size: 13px;
    line-height: 18px;
    word-break: keep-all;
    overflow: hidden;
  }
  .section .cols2 .items a .prd-name font {
    font-weight: bold;
  }
  .section .cols2 .items a .prd-name-sub {
    border-top: 1px solid #eaeaea;
    color: #979797;
    font-size: 11px;
    line-height: 14px;
    margin-top: 5px;
    padding-top: 7px;
    font-weight: normal;
  }
  .section .cols2 .items a .prd-name-sub font {
    font-weight: normal;
  }
  .section .cols2 .items a .priceBox {
    margin: 7px 0 5px;
    position: relative;
  }
  .section .cols2 .items a .priceBox .percent {
    padding-right: 3px;
    color: #ff4000;
    font-weight: 500;
    font-size: 13px;
  }
  .section .cols2 .items a .priceBox .slod-out {
    font-size: 11px;
    color: #ff0004;
    font-weight: 600;
  }
  .section .cols2 .items a .priceBox .slod-out2 {
    font-size: 11px;
    color: #1f6aff;
    font-weight: 600;
  }
  .section .cols2 .items a .priceicon {
    position: relative;
    text-align: right;
    height: 25px;
  }
  .section .cols2 .items a .priceicon img {
    margin-left: 3px;
  }
  .section .cols2 .items a .priceicon .style-code {
    position: absolute;
    left: 0;
    top: 0;
    font-size: 11px;
    height: 19px;
    line-height: 19px;
    color: #979797;
  }
  .section .cols2 .items a .discount {
    color: #000;
    font-size: 14px;
    font-weight: 600;
  }
  .section .cols2 .items a .prd-price {
    color: #000;
    font-size: 14px;
    font-weight: 500;
    line-height: 15px;
    display: inline-block;
    margin-right: 4px;
  }
  .section .cols2 .items a .prd-price strike {
    color: #979797;
    font-weight: normal;
    font-size: 12px;
  }

  .section .cols3.list-tab-view {
    width: 100%;
    box-sizing: border-box;
    padding: 0 15px;
  }
  .section .cols3 ul {
    padding: 0 20px;
    margin-bottom: 35px;
  }
  .section .cols3 ul:last-child {
    margin-bottom: 0px;
  }
  .section .cols3 ul:after {
    display: block;
    clear: both;
    content: '';
  }
  .section .cols3 .box {
    font-size: 0;
  }
  .section .cols3 .items li {
    float: left;
    width: 33.3%;
    vertical-align: top;
    box-sizing: border-box;
    text-align: left;
    margin-bottom: 30px;
    padding: 0 10px;
  }
  .section .cols3 .items .name_con {
    height: 73px;
    overflow: hidden;
  }
  .section .cols3 .items li:nth-child(3n + 1) {
    clear: both;
  }
  .section .cols3 .items li:nth-child(3n + 2) {
  }
  .section .cols3 .items li:nth-child(3n + 3) {
  }
  .section .cols3 .items.bigThumb {
    width: 100%;
  }
  .section .cols3 .items a {
    display: inline-block;
    width: 100%;
  }
  .section .cols3 .items a .img {
    margin-bottom: 15px;
    position: relative;
  }
  .section .cols3 .items a .img .no {
    position: absolute;
    color: #fff;
    background: #000;
    padding: 0 5px;
    height: 25px;
    line-height: 25px;
    top: 0;
    left: 0;
    font-size: 10px;
    font-weight: 500;
  }
  .section .cols3 .items a .img .no p {
    display: inline-block;
    margin-left: 3px;
  }
  .section .cols3 .items.bigThumb a .img .no {
    font-size: 12px;
    padding: 0 7px;
  }
  .section .cols3 .items a .prd-name {
    color: #000;
    font-size: 11px;
    line-height: 15px;
    word-break: keep-all;
  }
  .section .cols3 .items a .prd-name font {
    font-weight: bold;
  }
  .section .cols3 .items a .prd-name-sub {
    padding: 3px 0px;
    color: #e07289;
    font-size: 10px;
    line-height: 13px;
  }
  .section .cols3 .items a .prd-name-sub font {
    font-weight: normal;
  }
  .section .cols3 .items .priceBox {
    margin-top: 7px;
    padding-top: 7px;
    border-top: 1px solid #eaeaea;
    position: relative;
  }
  .section .cols3 .items .priceBox .prd-price {
    display: inline-block;
    font-size: 13px;
    color: #000;
    margin-right: 7px;
    font-weight: 500;
  }
  .section .cols3 .items .priceBox .prd-price strike {
    color: #bbb;
    font-weight: normal;
    font-size: 12px;
  }
  .section .cols3 .items .priceBox .discount {
    color: #ff0004;
    font-size: 13px;
    font-weight: 500;
  }
  .section .cols3 .items a .priceicon {
    position: relative;
  }
  .section .cols3 .items a .priceicon .discount {
    color: #ff0004;
    font-size: 13px;
    font-weight: 500;
  }
  .section .cols3 .items a .prd-price {
    color: #818181;
    font-size: 10px;
    line-height: 15px;
  }
  .section .cols3 .items a .crema-product-reviews-count {
    color: #949494;
    font-size: 10px !important;
    line-height: 15px;
    margin-top: 7px;
  }
  .section .cols3 .items a .crema-product-reviews-count b {
    color: #e93388;
    font-weight: 500;
  }
  .section .cols3 .items.bigThumb a .crema-product-reviews-count {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 11px !important;
    color: #949494;
  }
  .section .cols3 .items.bigThumb a .crema-product-reviews-count b {
    font-weight: 500;
    color: #e93388;
  }

  #MS_product_more_btn_area {
    text-align: center;
    width: 100%;
  }
  #MS_product_more_btn_area .more a {
    display: block;
    width: 90%;
    height: 40px;
    margin: 0 auto;
    border: 1px solid #d0d0d0;
    background: #fff;
    color: #a6a6a6;
    font-size: 11px;
    letter-spacing: 2px;
    line-height: 40px;
    text-align: center;
  }

  #product-list .title-text {
    position: relative;
    padding: 25px 4% 20px;
    font-size: 22px;
    font-weight: 600;
    text-align: left;
  }
  #product-list .title-text a {
    position: absolute;
    top: 22px;
    right: 11px;
    height: 22px;
  }
  #product-list .title-text a img {
    width: auto;
    height: 100%;
  }

  .main_popup_box {
    box-sizing: border-box;
  }

  #container #product-list .results .tool-wrap .links select {
    width: 140px;
    height: 30px;
    line-height: 30px;
    color: #333;
    font-size: 12px;
    font-weight: 300;
    border: 0;
    border-bottom: 1px solid #000;
    background: url(https://xexymix.jpg3.kr/xexymix/PL/img/select_arrow.png) no-repeat 95% 50%;
    background-size: 10%;
    -webkit-appearance: none; /* 화살표 없애기 for chrome*/
    -moz-appearance: none; /* 화살표 없애기 for firefox*/
    appearance: none; /* 화살표 없애기 공통*/
  }
  #container #product-list .results .tool-wrap .links {
    position: absolute;
    right: 10px;
    top: 5px;
    width: 140px;
  }

  /* .item-sort */
  .item-sort {
    position: relative;
    height: 40px;
    margin-bottom: 20px;
  }
  .item-sort .ea {
    font-size: 12px;
    font-weight: 300;
    line-height: 40px;
    text-align: left;
    padding-left: 15px;
  }
  .item-sort .ea strong {
    font-size: 13px;
    font-weight: 600;
  }
  .sort-menu {
    position: absolute;
    top: 50%;
    right: 0;
    z-index: 5;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    transform: translate(0, -50%);
  }
  .sort-menu .sort-btn {
    cursor: pointer;
    display: block;
    font-size: 13px;
    width: 90px;
    line-height: 40px;
    padding-left: 18px;
  }
  .sort-menu .sort-btn:after {
    content: '';
    display: block;
    width: 6px;
    height: 6px;
    position: absolute;
    right: 22px;
    top: 14px;
    transform: rotate(45deg);
    border-bottom: 2px solid #666;
    border-right: 2px solid #666;
    transition: 0.4s;
  }
  .sort-menu .sort-list {
    position: absolute;
    display: none;
    width: 100px;
    box-sizing: border-box;
    background: #fff;
    padding: 12px 18px;
    border: 1px solid #666;
  }
  .sort-menu .sort-list li {
    list-style: none;
    line-height: 30px;
    box-sizing: border-box;
  }
  .sort-menu .sort-list li a {
    font-size: 13px;
    color: #666;
  }
  .sort-menu .sort-list li a:hover {
    color: #111;
  }
  .sort-menu .sort-btn.active:after {
    border-bottom: 2px solid #666;
    border-right: 2px solid #666;
    transform: rotate(-135deg);
    top: 18px;
    transition: 0.4s;
  }
  .sort-menu .sort-list.opened {
    display: block;
  }

  .section .cols2 .items a .crema-product-reviews-count {
    color: #ef987f;
    font-size: 10px !important;
    line-height: 19px;
    position: absolute;
    right: 0;
    top: 0;
  }
  .section .cols2 .items a .crema-product-reviews-count b {
    font-weight: 500;
  }

  /* 버튼 커스텀 */
  /* 게시판 글쓰기, 목록보기 */
  .button02-wh {
    padding: 10px 43px;
    color: #cacaca;
    background-color: #fff;
    border: 1px solid #cacaca;
    font-size: 12px;
    -webkit-border-radius: 0px;
    border-radius: 0px;
  }
  .button03-pu {
    padding: 10px 43px;
    color: #fff;
    background-color: #5a274b;
    border: 1px solid #5a274b;
    font-size: 12px;
    -webkit-border-radius: 0px;
    border-radius: 0px;
  }
  /* 게시글 보기 패스워드 입력 작은 버튼 */
  .button04-s-wh {
    padding: 8px 21px;
    color: #cacaca;
    background-color: #fff;
    border: 1px solid #cacaca;
    font-size: 12px;
    -webkit-border-radius: 0px;
    border-radius: 0px;
  }
  .button04-s-pu {
    padding: 8px 21px;
    color: #fff;
    background-color: #5a274b;
    border: 1px solid #5a274b;
    font-size: 12px;
    -webkit-border-radius: 0px;
    border-radius: 0px;
  }

  /* 마이페이지 쿠폰등록 보라색 */
  .button04-m {
    float: right;
    padding: 10px 43px;
    background-color: #fff;
    border: 1px solid #cacaca;
    font-size: 13px;
    -webkit-border-radius: 0px;
    border-radius: 0px;
  }

  .btn-group {
    margin: 10px 15px 30px 15px;
  }
  .btn-group:after {
    display: block;
    clear: both;
    content: '';
  }
  .btn-group .shopping-btn {
    width: 100%;
    padding-right: 2.5px;
    margin-bottom: 5px;
  }
  .btn-group .all-delete {
    float: left;
    width: 50%;
    padding-left: 2.5px;
    margin-bottom: 5px;
  }
  .btn-group .shopping-btn a,
  .btn-group .all-delete a {
    display: block;
    width: 100%;
    border: 1px solid #000;
    color: #000;
    font-size: 14px;
    font-weight: 400;
    line-height: 38px;
    text-align: center;
  }
  .btn-group .all-order {
    width: 100%;
    margin-bottom: 10px;
  }
  .btn-group .all-order a {
    display: block;
    width: 100%;
    background: #000;
    border: 1px solid #000;
    color: white;
    font-size: 14px;
    font-weight: 400;
    line-height: 38px;
    text-align: center;
  }

  #container #wish .btn-group .all-delete a {
    background: #000 !important;
  }
  #container #wish .page-tab a.active {
    background: #000 !important;
  }
  #container #wish .page-tab {
    border-bottom: 1px solid #000 !important;
  }
  #container #recent .btn-group .all-delete a {
    background: #000 !important;
  }
  #container #recent .page-tab a.active {
    background: #000 !important;
  }
  #container #recent .page-tab {
    border-bottom: 1px solid #000 !important;
  }
  #review-board-type .reply-write .custom a.btn-gray-h25 strong {
    width: 0 !important;
    margin-top: 0 !important;
  }
  .ppoint a {
    background: #000 !important;
  }
  .ppoint {
    background: #000 !important;
  }
  .about-text p strong {
    color: #000 !important;
  }

  img.MS_prod_img_s {
    width: 100%;
  }
  img.MS_prod_img_l {
    width: 100%;
  }
  .swiper-slide img {
    width: 100%;
  }

  .flex {
    display: -webkit-flex;
    display: -ms-flex;
    display: flex;
  }

  .MK-product-icons img {
    padding-right: 3px;
  }

  .swiper-button-prev,
  .swiper-button-next {
    display: none;
    outline: 0;
  }

  /* BASIC css start */
  .headerFixed .cate-header {
    display: none;
  }
  html.fixed .rightFixBtn {
    bottom: 50px;
  }
  html.fixed .quick-menu {
    bottom: 60px;
  }

  /* 멤버쉽할인가 */
  .mpBtn {
    position: relative;
    padding-right: 17px;
    font-size: 13px;
    cursor: pointer;
  }
  .mpBtn:after {
    content: '';
    position: absolute;
    top: 2px;
    right: 0;
    background: url(https://www.xexymix.com/design/xexymix/image/p_next.png) no-repeat center;
    width: 12px;
    height: 12px;
    transform: rotate(90deg);
  }
  .memberPrice {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 200px;
    z-index: 10;
    background: #fff;
    border-top: 1px solid #dfdfdf;
    border-left: 1px solid #dfdfdf;
    border-right: 1px solid #dfdfdf;
    font-size: 12px;
    line-height: 33px;
  }
  .memberPrice .mtit {
    position: relative;
    padding: 0 5%;
    border-bottom: 1px solid #dfdfdf;
    cursor: pointer;
  }
  .memberPrice .mtit .mpBtn_x {
    position: absolute;
    top: 0;
    right: 0;
    width: 33px;
    height: 33px;
    text-align: center;
    font-size: 15px;
  }
  .memberPrice .mlist {
  }
  .memberPrice .mlist ul {
    overflow: hidden;
    padding: 0 5%;
    border-bottom: 1px solid #dfdfdf;
  }
  .memberPrice .mlist ul:nth-child(6) {
    display: none;
  }
  .memberPrice .mlist ul:last-child {
    display: none;
  }
  .memberPrice .mlist li {
    display: inline-block;
    padding-bottom: 0 !important;
  }
  .memberPrice .mlist li:first-child {
    text-align: left;
    width: 60%;
  }
  .memberPrice .mlist li:last-child {
    text-align: right;
    width: 38%;
    font-weight: 600;
  }
  .memberPrice .mlist2 ul {
    overflow: hidden;
    padding: 0 5%;
    border-bottom: 1px solid #dfdfdf;
  }
  .memberPrice .mlist2 li {
    display: inline-block;
    padding-bottom: 0 !important;
  }
  .memberPrice .mlist2 li:first-child {
    text-align: left;
    width: 60%;
  }
  .memberPrice .mlist2 li:last-child {
    text-align: right;
    width: 38%;
    font-weight: 600;
  }
  .memberPrice.show {
    display: block;
  }

  /* 컬러네비 */
  #colorBtn {
    display: none;
    position: absolute;
    top: 146px;
    left: -29px;
    width: 70px;
    height: 26px;
    line-height: 26px;
    border: 1px solid #000;
    padding-left: 10px;
    border-radius: 7px 7px 0 0;
    background: #fff;
    z-index: 10;
    font-size: 12px;
    font-weight: 500;
    transform: rotate(90deg);
  }
  #colorBtn span:before {
    content: '';
    position: absolute;
    top: 3px;
    left: 0;
    width: 20px;
    height: 20px;
    background: url(//xexymix.jpg3.kr/xexymix/2020m/sub/detail/color_btn_icon.png) no-repeat;
    background-size: cover;
    transform: rotate(180deg);
    overflow: hidden;
  }
  #colorCont {
    position: absolute;
    top: 0;
    left: -100%;
    bottom: 0;
    width: 80px;
    z-index: 999;
    transition: all 0.5s ease;
    padding-bottom: 50px;
  }
  #colorCont.show {
    left: 0;
    visibility: visible;
  }
  #colorCont .colorClose {
    position: absolute;
    top: 146px;
    left: 52px;
    width: 70px;
    height: 26px;
    line-height: 26px;
    border: 1px solid #000;
    border-bottom: 1px solid #fff;
    padding-left: 10px;
    border-radius: 7px 7px 0 0;
    background: #fff;
    z-index: 1001;
    font-size: 12px;
    font-weight: 500;
    transform: rotate(90deg);
    overflow: hidden;
  }
  #colorCont .colorClose a:before {
    content: '';
    position: absolute;
    top: 3px;
    left: 1px;
    width: 20px;
    height: 20px;
    background: url(//xexymix.jpg3.kr/xexymix/2020m/sub/detail/color_btn_icon.png) no-repeat;
    background-size: cover;
  }
  #colorCont .colorBox {
    position: relative;
    z-index: 1000;
    width: auto;
    height: 100%;
    padding: 30px 15px;
    overflow: scroll;
    background: #fff;
    border-right: 1px solid #000;
  }
  #colorCont .colorBox a {
    display: block;
    width: 50px;
    height: 50px;
    margin-bottom: 12px;
  }
  #colorCont .colorTit {
    padding: 5px;
    border-bottom: 2px solid #000;
    margin-bottom: 15px;
    font-size: 14px;
    font-weight: 600;
    line-height: 15px;
  }

  /*상품명*/
  .info-wrap {
    position: relative;
    margin: 16px 16px 0;
    padding-bottom: 16px;
    border-bottom: 2px solid #000;
  }
  .info-wrap .prd-name {
    font-size: 17px;
  }
  .info-wrap .prd-name-sub {
    color: #979797;
    font-size: 12px;
    margin-top: 8px;
  }
  .info-wrap .btn-example {
    position: absolute;
    bottom: 16px;
    right: 0;
    font-weight: 700;
    font-size: 13px;
    vertical-align: middle;
  }
  .info-wrap .btn-example span {
    font-size: 16px;
    font-weight: 600;
  }
  .info-wrap .prd-style-code {
    padding-top: 8px;
    font-size: 13px;
  }
  .info-wrap .prd-name-wi {
    margin-top: 8px;
    font-size: 11px;
    color: #ef987f;
  }

  /*탭메뉴*/
  .cont-tit {
    font-size: 20px;
    font-weight: 600;
    padding: 20px 4% 10px;
  }
  .cont-tit span {
    font-size: 14px;
    font-weight: normal;
  }
  .section-cont {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    border-bottom: 10px solid #f1f1f1;
  }
  .section-cont-nav {
    position: absolute;
    top: 0px;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 100%;
    height: 0px;
    margin: 0 auto;
    box-sizing: border-box;
  }
  .section-cont-nav.fixed {
    position: absolute;
    z-index: 10;
    bottom: inherit;
    left: 0;
    right: 0;
    width: 100%;
    margin: 0 auto;
    -webkit-transition: top 0.3s ease;
    -moz-transition: top 0.3s ease;
    -ms-transition: top 0.3s ease;
    -o-transition: top 0.3s ease;
    transition: top 0.3s ease;
  }
  .section-cont-nav ul {
    width: 100%;
    text-align: center;
    position: absolute;
    left: 0px;
    top: 0px;
    padding: 0;
    margin: 0;
    background: #fff;
    border-bottom: 1px solid #000;
    border-top: 1px solid #e6e6e6;
  }
  .section-cont-nav ul li {
    position: relative;
    float: left;
    display: block;
    cursor: pointer;
    width: 25%;
  }
  .section-cont-nav ul li a {
    display: block;
    width: 100%;
    height: 33px;
    line-height: 33px;
    color: #000;
    text-align: center;
    text-decoration: none;
  }
  .section-cont-nav ul li a.active:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: #000;
  }
  .section-cont-nav ul li a.line:after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
    right: 0;
    width: 1px;
    height: 100%;
    background: #e6e6e6;
  }
  .section-cont-nav .crema-product-reviews-count {
    color: #ff6d44;
    font-size: 11px;
  }

  #container #review iframe {
    max-width: 100% !important;
  }

  #container .benefit {
    margin: 20px 0 0;
  }
  #container .benefit h3 {
    padding-bottom: 15px;
    margin: 0 3%;
    border-bottom: 1px solid #e6e6e6;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: -0.5px;
  }
  #container .benefit img {
    width: 100%;
  }

  #container .washing-btn {
    display: block;
    margin: 10px 15px;
    border: 1px solid #333;
    font-size: 15px;
    font-weight: 400;
    line-height: 41px;
    text-align: center;
    box-sizing: border-box;
  }
  #container .delivery-btn {
    display: block;
    margin: 10px 15px;
    border: 1px solid #333;
    font-size: 15px;
    font-weight: 400;
    line-height: 41px;
    text-align: center;
    box-sizing: border-box;
  }
  #container .exchange-btn {
    display: block;
    margin: 0px 15px;
    margin-bottom: 40px;
    border: 1px solid #333;
    font-size: 15px;
    font-weight: 400;
    line-height: 41px;
    text-align: center;
    box-sizing: border-box;
  }

  #container #qna {
  }
  #container #qna li {
    display: block;
    border-bottom: 1px solid #dadada;
  }
  #container #qna li.empty {
    color: #333333;
    font-size: 12px;
    font-weight: 300;
    line-height: 25px;
    text-align: center;
  }
  #container #qna li a {
    display: inline-block;
    width: 100%;
    padding: 15px;
    box-sizing: border-box;
  }
  #container #qna li a h5 {
    font-size: 13px;
    font-weight: 400;
    line-height: 25px;
  }
  #container #qna li a h5 dd {
    display: inline-block;
  }
  #container #qna li a p {
    margin-top: 5px;
    color: #888888;
    font-size: 11px;
    font-weight: normal;
  }

  #container #qna .board-btns {
    margin: 0px 15px;
    margin-bottom: 50px;
  }
  #container #qna .board-btns a {
    display: inline-block;
    width: 100%;
    border: 1px solid #e1e1e1;
    color: #333333;
    font-size: 13px;
    font-weight: 300;
    line-height: 38px;
    text-align: center;
    box-sizing: border-box;
  }
  #container #qna .board-btns a.write-btn {
    display: inline-block;
    width: 100%;
    margin-top: 10px;
    background: #000;
    color: white;
    font-size: 13px;
    font-weight: 300;
    line-height: 40px;
    text-align: center;
    box-sizing: border-box;
  }

  /*같이코디한&추천 상품*/
  .related-product {
    margin: 0 3%;
    padding: 20px 0 16px;
  }
  .related-product h3.toggle {
    display: block;
    text-align: left;
    position: relative;
    padding-top: 20px;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: -0.5px;
  }

  .related-product .items[data-type='vertical'] .thumb-img img {
    width: 100%;
    border-radius: 0;
  }
  .related-product .items[data-type='vertical'] .pname a {
    font-size: 13px;
    margin: 10px 0 0 0;
    display: inline-block;
    height: 18px;
    overflow: hidden;
  }
  .related-product .items[data-type='vertical'] .prd-sub-name a {
    color: #dc778c;
    font-size: 11px;
    line-height: 15px;
    height: 30px;
    display: block;
  }

  .related-product .items-wrap .items[data-type='vertical'] li.related_list {
    border-bottom: 0;
  }
  .related-product .items-wrap .items[data-type='vertical'] .price-info.price-info .btn-type-02 {
    height: 24px;
    box-sizing: border-box;
  }
  .related-product .items-wrap .codi-pagination {
    position: absolute;
    right: 0;
    left: auto;
    top: 22px;
    text-align: right;
  }
  .related-product .items-wrap .codi-pagination .swiper-pagination-bullet-active {
    background: #000;
  }
  .related-product .items-wrap .recommend-pagination {
    position: absolute;
    right: 0;
    left: auto;
    top: 22px;
    text-align: right;
  }
  .related-product .items-wrap .recommend-pagination .swiper-pagination-bullet-active {
    background: #000;
  }
  .related-product ul .option_btn {
    background: #666;
    padding: 0px 50px;
    display: inline-block;
    color: #fff;
    border-radius: 0px;
    margin: 5px 10px 0 0;
    float: right;
    height: 30px;
    line-height: 30px;
    box-sizing: border-box;
  }

  .related-product .related-btn .btn-type-03 {
    padding: 0;
    background: #fff !important;
    border-radius: 0;
    width: 99.4%;
  }
  .related-product .items-wrap .items[data-type='vertical'] .pname {
    text-align: left !important;
    padding: 0;
    font-weight: normal !important;
  }

  .related-product .related_list .price_box p.prd-price {
    color: #000;
    font-size: 13px;
    font-weight: 600;
  }
  .related-product .related_list .price_box p.prd-price strike {
    line-height: inherit;
    font-size: 0.8em;
    color: #828282;
    margin-left: 6px;
    font-weight: 300;
  }
  .related-product .related_list .price_box .crema-product-reviews-count {
    position: absolute;
    right: 0;
    font-size: 10px !important;
    color: #ef987f;
  }
  .related-product .related_list .price_box .crema-product-reviews-count b {
    font-weight: 500;
  }

  .related-product .items-wrap p.prd-name-sub {
    overflow: hidden;
    margin-bottom: 8px;
  }
  .related-product p.prd-name-sub a {
    color: #979797;
    font-size: 10px;
    font-weight: 300;
  }

  .items-wrap .items[data-type='vertical'] > li .con_box .thumb-img {
    width: 100%;
    margin-left: 0;
    margin-top: 0;
  }
  ul.swiper-wrapper.items {
    display: flex !important;
  }

  /*주의사항안내*/
  .washing-layer {
    display: none;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 5001;
    overflow-y: scroll;
  }
  .washing-layer .washing-wrap {
    position: relative;
    background: white;
    padding: 5px;
    margin: 15px;
  }
  .washing-layer .washing-wrap .title {
    margin-bottom: 23px;
    color: #333333;
    font-size: 14.5px;
    line-height: 20px;
  }
  .washing-layer .washing-wrap .close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 28px;
    height: 28px;
  }
  .delivery-layer {
    display: none;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 5001;
    overflow-y: scroll;
  }
  .exchange-layer {
    display: none;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 5001;
    overflow-y: scroll;
  }
  .example-layer {
    display: none;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 5001;
    overflow-y: scroll;
  }
  .example-layer .example-wrap {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    -webkit-box-align: center;
    -webkit-box-pack: center;
    -ms-flex-align: center;
  }

  .xexy_notice {
    background: #f7f7f7;
    border: 1px solid #c6c6c6;
    padding: 5%;
    margin: 5% 5% 10% 5%;
    font-size: 12px;
    line-height: 20px;
    color: #111;
    text-align: left;
  }

  .shopdetail .shopdetailInfo {
  }
  .shopdetail .shopdetailInfo h2 {
    font-size: 1.333em;
    font-weight: bold;
    text-align: center;
    padding-top: 16px;
  }
  .shopdetail h3 .fa {
    float: right;
    font-size: 1.5em;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoTop figure {
    padding: 16px 15px;
    border-bottom: 1px solid #c7c7c7;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoTop figcaption {
    text-align: left;
    margin-top: 16px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoTop img {
    width: 100%;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoTop .thumbSlide .swiper-pagination-bullet-active {
    background: #000;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom {
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoValue {
    position: relative;
    margin: 0 16px;
    padding: 16px 0;
    border-bottom: 1px solid #e5e5e5;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoValue li {
    padding-bottom: 8px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoValue li:last-child {
    padding-bottom: 0;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoValue .tit {
    min-width: 90px;
    font-weight: 500;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoValue .txt {
    position: relative;
    font-weight: 500;
    font-size: 14px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoValue .tit.dc_price_sell {
    margin: auto 0;
    line-height: 30px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoValue .txt strong {
    font-size: 16px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoValue .dc_period {
    margin: auto 0 auto 16px;
    line-height: 30px;
  }
  .shopdetailInfoDelivery {
    padding: 10px 15px;
  }
  /* 상품옵션 */
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area {
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area.fixed {
    width: 100%;
    position: absolute;
    z-index: 997;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: 0px 0px 20px rgb(0 0 0 / 30%);
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area.fixed {
    -webkit-animation: qbuy 150ms linear 1 normal;
    animation: qbuy 150ms linear 1 normal;
  }
  @-webkit-keyframes qbuy {
    from {
      bottom: -65px;
    }
    to {
      bottom: 0;
    }
  }
  @keyframes qbuy {
    from {
      bottom: -65px;
    }
    to {
      bottom: 0;
    }
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area.fixed .option_tk {
    max-height: 400px;
    overflow-y: auto;
    background-color: #fff;
    padding-top: 40px;
    border-top: 1px solid #e5e5e5;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .fixed-btn {
    box-sizing: border-box;
    position: relative;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 101;
    text-align: center;
    margin: 0 auto;
    display: none;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .fixed-btn .btn_Red {
    background-color: #000;
    width: 86.5%;
    height: 50px;
    line-height: 50px;
    color: #fff;
    font-size: 15px;
    font-weight: 500;
    float: left;
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .fixed-btn .btn-wish {
    background-color: #fff;
    width: 13.5%;
    height: 50px;
    float: left;
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .fixed-btn .btn-wish img {
    width: 20px;
    margin-top: 15px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .fixed-btn.fixed {
    display: block;
    position: absolute;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .fixed-btn .btn_option {
    display: none;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area.fixed .fixed-btn.fixed .btn_option {
    display: block;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area.fixed .fixed-btn.fixed {
    display: block;
    position: relative;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .fixed-btn .btn_option {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 15px;
    height: 15px;
    background: url(https://xexymix.jpg3.kr/xexymix/2020/sub/detail/popup_close.gif) no-repeat center;
    background-size: cover;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoMultiSelect {
    background-color: #fff;
  }

  .shopdetail .shopdetailInfo .shopdetailInfoBottom .buy_on {
    display: none;
    background-color: #fff;
    padding: 0 16px 16px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .buy_on ul {
    display: flex;
    margin-bottom: 10px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .buy_on ul li {
    display: contents;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .buy_on ul li a {
    width: 100%;
    height: 100%;
    font-size: 15px !important;
    font-weight: 500 !important;
    text-align: center;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .buy_on ul li a.btn-cart {
    background: #fff;
    color: #000;
    border: 1px solid #000;
    height: 50px;
    line-height: 50px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .buy_on ul li a.btn-buy {
    background: #000;
    color: #fff;
    border: 1px solid #000;
    height: 50px;
    line-height: 50px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .buy_on ul li a.btn-wish {
    background: #fff;
    border: 1px solid #000;
    width: 60px;
    height: 50px;
    line-height: 50px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .buy_on ul li a.btn-wish img {
    height: 20px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .buy_on ul li .offline_btn {
    background: #fff;
    color: #000;
    border: 1px solid #000;
    height: 50px;
    line-height: 50px;
    border-left: 0;
  }

  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoSelect {
    padding-top: 5px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoSelect .opt-com {
    text-align: right;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoSelect p {
    padding-top: 5px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoSelect p:last-child {
    margin-bottom: 0px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoSelect .shopdetailInfoName {
    width: 25%;
    display: inline-block;
    line-height: 29px;
    font-weight: 500;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoSelect .shopdetailInfoCont {
    width: 74%;
    display: inline-block;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoSelect .shopdetailInfoCont select {
    width: 100%;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoSelect .shopdetailInfoCount .txt-qnty {
    text-align: right;
    padding: 0 6px;
    width: 50px !important;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoSelect .shopdetailInfoCount .fa-plus {
    background-color: #bbb;
    width: 35px;
    height: 35px;
    text-align: center;
    vertical-align: middle;
    line-height: 35px;
    color: #fff;
    margin: 0 5px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoSelect .shopdetailInfoCount .fa-minus {
    background-color: #bbb;
    width: 35px;
    height: 35px;
    text-align: center;
    vertical-align: middle;
    line-height: 35px;
    color: #fff;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoMultiSelect .MK_optAddWrap #MK_innerOptScroll {
    background-color: #fafafa;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoSelect .add-option-sel {
    font-weight: bold;
    font-size: 1.1em;
    padding-top: 10px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoSelect .add-option select {
    margin-bottom: 10px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoSelect .add-option .shopdetailInfoName {
    vertical-align: top;
    padding-top: 11px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoValue .shopdetailInfoCont.listCoupon {
    position: relative;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoValue .shopdetailInfoCont .btn-coupon {
    display: inline-block;
    height: 16px;
    padding: 0;
    margin-left: 5px;
    border: 1px solid #000;
    font-size: 10px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoValue .shopdetailInfoCont .btn-coupon span {
    display: inline-block;
    height: 16px;
    padding: 0 5px;
    color: #fff;
    background: #000;
    vertical-align: top;
    font-size: 11px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailInfoValue .shopdetailInfoCont .btn-coupon em {
    display: inline-block;
    height: 16px;
    padding: 0 3px 0 0;
    font-size: 10px;
    vertical-align: top;
    color: #000;
  }
  .shopdetail .shopdetailBoard {
    text-align: center;
    border-top: 1px solid #bbb;
    border-bottom: 1px solid #bbb;
    margin-bottom: 32px;
  }
  .shopdetail .shopdetailBoard a {
    width: 33.33%;
    background-color: #f8f8f8;
    border-left: 1px solid #bbb;
    display: inline-block;
    margin-left: -1px;
    font-weight: bold;
    padding: 20px 0;
  }

  .MK_optAddWrap .MK_inner-opt-cm li {
    display: flex;
    position: relative;
    height: 25px;
    border-top: 1px solid #e5e5e5 !important;
    border-bottom: 0 !important;
    padding: 10px 0 !important;
    margin: 0 !important;
    background-color: #fff !important;
  }
  .MK_optAddWrap .MK_inner-opt-cm li:last-child {
    border-bottom: 0px none;
  }
  .MK_optAddWrap .MK_inner-opt-cm .MK_p-name {
    display: block;
  }
  .MK_optAddWrap .MK_inner-opt-cm .MK_qty-ctrl {
    width: 80px !important;
    margin: 4px 8px auto auto;
    padding: 0;
    right: 120px !important;
  }
  .MK_optAddWrap .MK_inner-opt-cm .MK_qty-ctrl input[type='tel'] {
    width: 100%;
    height: 23px;
    line-height: 23px;
    padding: 0;
    margin: 0;
    outline: none;
    text-align: center !important;
  }
  .MK_optAddWrap .MK_inner-opt-cm .MK_btn-del {
    position: absolute;
    top: 12px;
    right: 0;
  }
  .MK_optAddWrap .MK_inner-opt-cm .MK_btn-del img {
    width: 20px;
    margin-right: 5px;
  }
  .MK_optAddWrap .MK_inner-opt-cm .MK_price {
    width: 70px;
    margin: auto 40px auto 0;
    color: #333;
    font-size: 12px;
    text-align: right;
    line-height: 27px;
  }
  .MK_optAddWrap .MK_inner-opt-cm .MK_qty-ctrl .btn-type-02 {
    background: url(https://www.xexymix.com/design/xexymix/renewal/mobile/img/common/detail_plus_btn.jpg) no-repeat
      center center;
    width: 23px;
    height: 23px;
    padding: 0;
    border: none;
    background-size: 23px 23px;
    position: absolute;
    top: 1px;
    right: 1px;
    display: inline-block;
  }
  .MK_optAddWrap .MK_inner-opt-cm .MK_qty-ctrl a:last-child {
    background: url(https://www.xexymix.com/design/xexymix/renewal/mobile/img/common/detail_minus_btn.jpg) no-repeat
      center center;
    background-size: 23px 23px;
    left: 1px;
  }

  .MK_optAddWrap .total {
    text-align: right;
    padding: 10px 15px;
    border-top: 2px solid #000;
  }
  .MK_optAddWrap .MK_txt-total {
    width: 25%;
    float: left;
    text-align: left;
    line-height: 35px;
    font-weight: 500;
    font-size: 12px;
  }
  .MK_optAddWrap .MK_total {
    color: #000 !important;
    font-size: 24px !important;
    font-weight: 600;
    line-height: 35px;
  }
  .MK_optAddWrap .MK_txt-won {
    font-size: 14px;
  }
  .MK_optAddWrap_div {
    height: 10px;
    padding: 0;
    background: #f6f6f6;
    border-top: 1px solid #c7c7c7;
    border-bottom: 1px solid #c7c7c7;
  }
  .MK_optAddWrap_line {
    height: 1px;
    padding: 0;
    background: #f6f6f6;
    border-bottom: 1px solid #c7c7c7;
  }
  #MK_innerOptTotal {
    padding: 16px 0;
    text-align: right;
  }

  #MK_innerOptWrap #MK_innerOpt_01 li .MK_p-name,
  #MK_innerOptWrap #MK_innerOpt_02 li .MK_p-name {
    display: inline-block;
    margin: auto 0;
    width: 35%;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  #MK_innerOptWrap .MK_inner-opt-cm li .MK_btn-del {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 40px;
    height: 40px;
    background: url(https://www.xexymix.com/design/xexymix/renewal/mobile/img/header/drawer-close-btn.png) no-repeat
      center center;
    background-size: 20px 20px;
  }
  #MK_innerOptWrap .MK_inner-opt-cm li .MK_btn-del img {
    display: none;
  }
  #MK_innerOptWrap .MK_inner-opt-cm li .MK_qty-ctrl .basic_option {
    margin-top: 0;
  }
  .btn-type-02 span,
  .btn-type-03 span {
    font-size: 0;
  }

  /* //착불 아이콘 */
  .shopdetail .shopdetailInfo .gray-delivery {
    padding: 2px;
    background-color: #fff;
    color: #656565;
    font-size: 0.875em;
    border-radius: 3px;
    border: 1px solid #656565;
  }
  /* //상품옵션 */
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailTotal {
    background-color: #fff;
    text-align: right;
    padding: 15px;
    font-size: 1.2em;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailTotal em {
    color: #f1191f;
    font-size: 1.333em;
    margin-left: 16px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailButton {
    padding: 0 16px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailButton .shopdetailButtonTop ul {
    display: flex;
    margin-bottom: 10px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailButton .shopdetailButtonTop ul li {
    display: contents;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailButton .shopdetailButtonTop ul li a {
    width: 100%;
    height: 100%;
    font-size: 15px !important;
    font-weight: 500 !important;
    text-align: center;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailButton .shopdetailButtonTop ul li a.btn-cart {
    background: #fff;
    color: #000;
    border: 1px solid #000;
    height: 50px;
    line-height: 50px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailButton .shopdetailButtonTop ul li a.btn-buy {
    background: #000;
    color: #fff;
    border: 1px solid #000;
    height: 50px;
    line-height: 50px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailButton .shopdetailButtonTop ul li a.btn-wish {
    background: #fff;
    border: 1px solid #000;
    width: 60px;
    height: 50px;
    line-height: 50px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailButton .shopdetailButtonTop ul li a.btn-wish img {
    height: 20px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailButton .shopdetailButtonTop ul li .offline_btn {
    background: #fff;
    color: #000;
    border: 1px solid #000;
    height: 50px;
    line-height: 50px;
    border-left: 0;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailButton .shopdetailButtonBottom {
    margin: 20px 0;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailButton .shopdetailButtonBottom img {
    margin: 0 2px;
    width: 45px;
    height: auto;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailButton p.is_soldout {
    width: 100%;
    line-height: 40px;
    font-weight: normal;
    font-size: 12px;
    text-align: center;
    border: 1px solid #dfdfdf;
  }
  .shopdetail .shopdetailCoupon {
    margin-top: 15px;
  }
  .shopdetail .shopdetailCoupon .shopdetailCouponGet {
    padding: 0 15px;
  }
  .shopdetail .shopdetailCoupon .shopdetailCouponGet .image_src {
    max-width: 100%;
    padding-bottom: 5px;
  }
  .shopdetail .shopdetailCoupon .shopdetailCouponGet li dl {
    height: 34px;
    background: url('https://www.xexymix.com//d3/m_04/bg_coupon@2x.gif') no-repeat left center;
    padding: 10px 0 10px 92px;
    border-bottom: 1px dashed #cbcbcb;
    position: relative;
    background-size: 81px auto;
  }
  .shopdetail .shopdetailCoupon .shopdetailCouponGet li:last-child {
    border-bottom: 0px none;
  }
  .shopdetail .shopdetailCoupon .shopdetailCouponGet .MS_coupon dt {
    width: 82px;
    position: absolute;
    top: 10px;
    left: 0;
    color: #fff;
    text-align: center;
  }
  .shopdetail .shopdetailCoupon .shopdetailCouponGet .MS_coupon dt strong {
    font-weight: normal;
  }
  .shopdetail .shopdetailCoupon .shopdetailCouponGet .MS_coupon h4 {
    font-weight: bold;
  }
  .shopdetail .shopdetailItem .shopdetailItemPopup {
    text-align: center;
    padding: 0 15px;
    margin: 22px 0;
  }
  .shopdetail .shopdetailItem .shopdetailItemPopup a {
    font-weight: bold;
    color: #fff;
    background-color: #636363;
    display: block;
    padding: 10px 0;
  }
  .shopdetail .shopdetailItem .shopdetailItemPopup .shopdetailItemZoom {
    height: 60px;
    padding: 0 0 0 75px;
    margin-top: 10px;
    background: url('https://www.xexymix.com/images/d3/m_04/bg_hand@2x.gif') no-repeat 20px center;
    line-height: 60px;
    background-size: 50px auto;
  }
  .shopdetail .shopdetailItem .shopdetailImage img {
    max-width: 100% !important;
    height: auto !important;
  }
  .shopdetail .shopdetailItem .shopdetailImage table {
    width: 100% !important;
  }
  .shopdetail .shopdetailItem .shopdetailImage object {
    width: 100% !important;
  }
  .shopdetail .shopdetailItem .shopdetailImage table {
    table-layout: auto !important;
  }
  .shopdetail .shopdetailItem .shopdetailNotify {
    margin-top: 24px;
  }
  .shopdetail .shopdetailItem .shopdetailNotify .shopdetailNotifyInfo {
    padding: 0 15px;
  }
  .shopdetail .shopdetailItem .shopdetailNotify .shopdetailNotifyInfo dt {
    font-weight: bold;
    margin-bottom: 2px;
  }
  .shopdetail .shopdetailItem .shopdetailNotify .shopdetailNotifyInfo dd {
    margin: 0 0 25px 6px;
  }
  .shopdetail .shopdetailRelationItem {
    padding: 0 15px 30px 15px;
  }
  .shopdetail .shopdetailRelationItem .listName input {
    float: right;
  }
  .shopdetail .shopdetailRelationItem .btn_cart {
    width: 290px;
    text-align: center;
    font-weight: bold;
    color: #fff;
    background-color: #393939;
    display: block;
    padding: 10px 0;
    margin: 0 auto;
  }

  /* IOS 디바이스 옵션 선택 시 자동 확대 방지 */
  input[type='text'],
  input[type='date'],
  input[type='tel'],
  input[type='number'],
  input[type='email'],
  input[type='password'],
  select {
    width: 100%;
    font-size: 14px;
    border: 1px solid #e5e5e5;
  }
  /* //IOS 디바이스 옵션 선택 시 자동 확대 방지 */

  /* OKDGG 버튼 */
  .shopdetail .okdgg-checkout {
    margin-top: 15px;
  }
  .shopdetail .okdgg-checkout img {
    max-width: 90%;
    height: auto;
  }
  /* //OKDGG 버튼 */

  /* 퀵바이 버튼 노출 시 커뮤니티 탭 위치 변경 */
  .cs-button {
    bottom: 53px !important;
  }
  /* //퀵바이 버튼 노출 시 커뮤니티 탭 위치 변경 */

  /* 임시품절 재입고 SMS 받기 */
  .shopdetail .soldout_anchor {
    display: block !important;
  }
  .shopdetail .MK_btn-sms {
    display: inline-block;
    width: 100%;
    height: 35px;
    line-height: 35px;
    text-align: center;
    border: 1px solid #808080;
    color: #fff;
    font-weight: bold;
    background-color: #636363;
    background-image: -webkit-gradient(linear, left top, left bottom, from(#636363), to(#5e5e5e));
    background-image: -webkit-linear-gradient(top, #636363, #5e5e5e);
    background-image: -moz-linear-gradient(top, #636363, #5e5e5e);
    background-image: -o-linear-gradient(top, #636363, #5e5e5e);
    background-image: linear-gradient(to bottom, #636363, #5e5e5e);
    -webkit-border-radius: 3px !important;
    border-radius: 3px !important;
    -moz-background-clip: padding;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
  }
  .shopdetail .MK_btn-sms span {
    padding-left: 24px;
    background: url(https://www.xexymix.com/images/d3/m_01/bull/alarm_fff@2x.png) no-repeat 0 50%;
    background-size: 18px 14px;
  }
  /* 임시품절 재입고 SMS 받기 끝 */

  #nhn_btn {
    padding-top: 10px;
  }
  #payco_order_btn {
    padding-top: 10px;
  }
  #kakaopay_order_btn {
    padding-top: 10px;
  }

  /* 하이브리드 */
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap {
    padding: 5px 15px 10px;
    background: #f6f6f6;
    border-bottom: 1px solid #c7c7c7;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .option-box:not(:last-child) {
    width: 100%;
    border-bottom: 1px solid #cecece;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .option-box.last {
    border-bottom: none;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .option-box .tit {
    width: 100%;
    padding: 10px 0;
    color: #3b3b3b;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .option-box .list:after {
    clear: both;
    content: '';
    display: block;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .option-box .list {
    width: 100%;
    font-size: 0.875em;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .option-box .list li {
    float: left;
    width: 20%;
    list-style: none;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .option-box .list li.last {
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .option-box .list li dl {
    width: 54px;
    padding-bottom: 10px;
    text-align: center;
    color: #333;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .option-box .list li dl dd.prdchk {
    text-align: left;
    padding-bottom: 5px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .option-box .list li dl dd.prdchk input {
    width: 12px;
    height: 12px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .option-box .list li dl dd.prdimg {
    position: relative;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .option-box .list li dl dd.prdimg img {
    width: 54px;
    height: 54px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .option-box .list li dl dd.prdimg.noimg {
    width: 52px;
    height: 52px;
    border: 1px solid #d8d8d8;
    background: #fff url(https://www.xexymix.com/makeshop/newmanager/neoimages/h52_noimg.gif) no-repeat center center;
  }
  .shopdetail
    .shopdetailInfo
    .shopdetailInfoBottom
    .option_area
    .option-wrap
    .option-box
    .list
    li
    dl
    dd.prdimg
    .soldout {
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    width: 54px;
    height: 54px;
    line-height: 56px;
    color: #fff;
    text-align: center;
  }
  .shopdetail
    .shopdetailInfo
    .shopdetailInfoBottom
    .option_area
    .option-wrap
    .option-box
    .list
    li
    dl
    dd.prdimg
    .soldout-bg {
    position: absolute;
    top: 50%;
    left: 0;
    display: inline-block;
    width: 54px;
    height: 20px;
    margin-top: -10px;
    background: #000;
    filter: alpha(opacity: 40);
    opacity: 0.4;
  }
  .shopdetail
    .shopdetailInfo
    .shopdetailInfoBottom
    .option_area
    .option-wrap
    .option-box
    .list
    li
    dl
    dd.prdimg
    .sel-img {
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    width: 54px;
    height: 54px;
    background: #000;
    filter: alpha(opacity: 40);
    opacity: 0.4;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .option-box .list li dl dd.prdname {
    padding-top: 5px;
    line-height: 14px;
    word-wrap: break-word;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .option-box .list li dl dd.prdnote {
    padding-bottom: 3px;
    line-height: 14px;
    word-wrap: break-word;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .option-box .list li dl dd.prdprice {
    padding-bottom: 3px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .option-box .list li dl dd.prdqty {
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .option-box .list li dl dd.prdqty input {
    display: inline-block;
    width: 20px;
    height: 15px;
    line-height: 17px;
    padding: 0 5px;
    border: 1px solid #707070;
    font-size: 11px;
    text-align: right;
  }
  .shopdetail
    .shopdetailInfo
    .shopdetailInfoBottom
    .option_area
    .option-wrap
    .option-box
    .list
    li
    dl
    dd.prdqty
    .btn-up-down {
    display: inline-block;
    width: 11px;
    height: 14px;
    line-height: 0;
    font-size: 0;
    vertical-align: top;
  }
  .shopdetail
    .shopdetailInfo
    .shopdetailInfoBottom
    .option_area
    .option-wrap
    .option-box
    .list
    li
    dl
    dd.prdqty
    .btn-up-down
    a {
    display: inline-block;
    width: 11px;
    height: 9px;
    line-height: 0;
    font-size: 0;
    vertical-align: top;
  }
  .shopdetail
    .shopdetailInfo
    .shopdetailInfoBottom
    .option_area
    .option-wrap
    .option-box
    .list
    li
    dl
    dd.prdqty
    .btn-up-down
    .btn-up {
    margin-bottom: 1px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .add-option-sel {
    font-weight: bold;
    font-size: 1.1em;
    padding: 10px 0;
    border-top: 1px solid #cecece;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .shopdetailInfoName {
    width: 28%;
    padding-right: 5px;
    display: inline-block;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .shopdetailInfoCont {
    width: 70%;
    display: inline-block;
    margin-left: -4px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .shopdetailInfoCont select {
    width: 100%;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .shopdetailInfoCount .txt-qnty {
    text-align: right;
    padding: 0 6px;
    width: 50px !important;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .shopdetailInfoCount .fa-plus {
    background-color: #bbb;
    width: 35px;
    height: 35px;
    text-align: center;
    vertical-align: middle;
    line-height: 35px;
    color: #fff;
    margin: 0 5px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option-wrap .shopdetailInfoCount .fa-minus {
    background-color: #bbb;
    width: 35px;
    height: 35px;
    text-align: center;
    vertical-align: middle;
    line-height: 35px;
    color: #fff;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .MK_optAddWrap #MK_innerOptPrice,
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .MK_optAddWrap #MK_innerOptAdd {
    padding-bottom: 5px;
    margin-right: 10px;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .MK_optAddWrap #MK_optAddWrapList {
    background-color: #f6f6f6;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .option_area .option_tk {
    padding: 0 16px;
  }

  /* 추가 구성 상품 */
  .shopdetail .shopdetailInfo .shopdetailInfoTit {
    height: 40px;
    line-height: 42px;
    padding: 0 12px;
    border-top: 1px solid #c7c7c7;
    border-bottom: 1px solid #c7c7c7;
    font-size: 14px;
    color: #000;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoWrap:after {
    clear: both;
    content: '';
    display: block;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoWrap {
    width: 100%;
    border-bottom: 1px solid #c7c7c7;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoWrap .shopdetailInfoTop {
    float: left;
    width: 45%;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoWrap .shopdetailInfoTop figure {
    padding: 15px 12px;
    border: 0;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoWrap .shopdetailInfoValue {
    float: right;
    width: 52%;
    padding: 15px 0;
    margin-right: 3%;
    border: 0;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoWrap .shopdetailInfoValue .shopdetailInfoprdName {
    font-size: 1.333em;
    font-weight: bold;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoWrap .shopdetailInfoValue .shopdetailInfoCont {
    width: auto;
    margin: 0;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoWrap .shopdetailInfoValue .shopdetailInfoName {
    width: auto;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoWrap .shopdetailInfoSelect p {
    padding: 0;
    background: none;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoWrap .shopdetailInfoSelect .shopdetailInfoCont .basic_option {
    width: 100%;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoWrap .shopdetailInfoSelect .shopdetailInfoName {
    display: none;
    width: 100%;
    padding: 0 0 5px 0;
  }

  /* 원클릭옵션 */
  .shopdetailInfoOneclick {
    clear: both;
    padding: 5px 0;
    overflow: hidden;
    zoom: 1;
  }
  .shopdetailInfoOneclick > span {
    float: left;
  }
  .shopdetailInfoOneclick .shopdetailInfoList {
    float: left;
    width: 70%;
    overflow-x: auto;
  }
  .MK-oneclick-only-image {
    width: max-content;
    padding-bottom: 5px;
  }
  .MK-oneclick-list {
    overflow: hidden;
    zoom: 1;
  }
  .MK-oneclick-list:after {
    content: '';
    display: block;
    clear: both;
  }
  .MK-oneclick-list li {
    float: left;
    margin: 0 5px 5px 0;
    background-color: #fff;
    border: 1px solid #e1e1e1;
  }
  .MK-oneclick-list li a {
    display: inline-block;
    border-radius: 1px;
    box-sizing: border-box;
  }
  .MK-oneclick-list li.MK-oneclick-sel {
    border: 1px solid #000;
  }
  .MK-oneclick-list li.MK-oneclick-sel a {
    color: #787878;
    transition: all 0.3s ease;
  }
  .MK-oneclick-list li.MK-oneclick-dis {
    position: relative;
    background-color: #666;
  }
  .MK-oneclick-list li.MK-oneclick-dis a {
    -moz-opacity: 0.5;
    opacity: 0.5;
    cursor: default;
    background-color: #fff;
  }
  .MK-oneclick-list li.MK-oneclick-color.MK-oneclick-sel a {
    padding: 1px;
    filter: alpha(opacity=100);
    -moz-opacity: 1;
    opacity: 1;
  }
  .MK-oneclick-list li a span {
    display: block;
    text-align: center;
    vertical-align: middle;
    line-height: 19px;
  }
  .MK-oneclick-list li a img {
    width: 100%;
    height: 100%;
  }
  .MK-oneclick-list li.MK-oneclick-image a {
    width: 70px;
    height: 70px;
  }
  .MK-oneclick-list li.MK-oneclick-image .MK-oneclick-title {
    width: 60px;
    padding: 5px;
    font-size: 12px;
    font-weight: 400;
    color: #999;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .MK-oneclick-list li.MK-oneclick-image.MK-oneclick-sel a img {
    height: 70px;
    width: auto;
  }
  .MK-oneclick-list li.MK-oneclick-color {
    width: 50px;
    height: 50px;
  }
  .MK-oneclick-list li.MK-oneclick-color a {
    padding: 2px;
  }
  .MK-oneclick-list li.MK-oneclick-color span {
    width: 44px;
    height: 44px;
  }
  .MK-oneclick-list li.MK-oneclick-color .mk-oo-sel span {
    width: 27px;
    height: 27px;
  }
  .MK-oneclick-list li.MK-oneclick-text .MK-oneclick-list li.MK-oneclick-text {
    min-width: 35px;
    max-width: 100%;
    height: 50px;
  }
  .MK-oneclick-list li.MK-oneclick-text .MS-oneclick-sel span {
    min-width: 30px;
    line-height: 27px;
  }
  .MK-oneclick-value {
    display: block;
    font-size: 13px;
    line-height: 27px;
    padding-right: 5px;
  }
  .MK-oneclick-only-text li.MK-oneclick-text {
    height: auto;
  }
  .MK-oneclick-only-text li.MK-oneclick-text span {
    padding: 4px 12px;
  }
  .MK-oneclick-list > li:not(.MK-oneclick-dis):hover {
    border: 1px solid #000;
    color: #000 !important;
  }
  .MK-oneclick-list > li:not(.MK-oneclick-dis) {
    transition: all 0.3s ease;
  }

  /* 게시글 */
  #tabs {
    padding-bottom: 50px;
  }
  #tabs .shopdetailBoard {
    overflow: hidden;
    text-align: center;
    border-top: 1px solid #bbb;
    border-bottom: 1px solid #bbb;
    background-color: #f8f8f8;
    padding: 10px 0;
    margin-bottom: 0;
  }
  #tabs .shopdetailBoard .tab_on {
    font-weight: bold;
    padding: 10px 0;
  }
  #tabs .util {
    border-bottom: 1px solid #dfdfdf;
    padding: 10px 3%;
  }
  #tabs .util .btn_Black {
    display: inline-block;
    width: 100%;
    border: 1px solid #000;
    margin-bottom: 10px;
    background: #000;
    color: white;
    font-size: 13px;
    line-height: 40px;
    text-align: center;
    box-sizing: border-box;
  }
  #tabs .util .btn_White {
    display: inline-block;
    width: 100%;
    border: 1px solid #000;
    color: #000;
    font-size: 13px;
    line-height: 40px;
    text-align: center;
    box-sizing: border-box;
  }
  #tabs .list_board .reply-detail {
    margin: 0 5px;
    border: 1px solid #73adff;
    font-size: 0.875em;
    color: #5da0ff;
    display: inline-block;
    height: 18px;
    line-height: 18px;
    padding: 0 3px;
  }
  #tabs .review .list_board > ul > li.now > .cont_wrap {
    display: block;
  }
  #tabs .list_board > ul > li > .wrap .re-wrap {
    padding: 10px;
    border-top: 1px solid #bebebe;
  }
  #tabs .empty-board {
    text-align: center;
    padding: 15px 0 5px;
  }
  .list_board ul li {
    color: #424242;
    border-bottom: 1px solid #dfdfdf;
    word-break: break-all;
  }
  .list_board .re-wrap ul li {
    font-size: 1em;
    border-bottom: 0;
    border-top: 1px dotted #bebebe;
    margin-top: 5px;
    padding-top: 5px;
    list-style: none;
  }
  .list_board ul li dl {
    padding: 15px;
  }
  .list_board ul li dt h4 {
    height: 22px;
    font-size: 13px;
  }
  .list_board ul li .info {
    color: #888;
  }
  .list_board ul li .cont_wrap {
    display: none;
    border-top: 1px dotted rgb(190, 190, 190);
    background-color: #f9f9f9;
    padding: 3%;
  }
  .list_board ul li .cont_wrap img {
    max-width: 100%;
    padding-bottom: 5px;
  }

  /* 댓글 */
  .MS_cmt_list_box {
    color: #656565;
  }
  .MS_cmt_list_box .comment_list:last-child {
    border-bottom: 1px solid #cecece;
  }
  .MS_cmt_list_box .comment_list {
    padding: 5px;
    border: 1px solid #cecece;
    border-bottom: 0;
    background-color: #fff;
  }
  .MS_cmt_list_box .MS_cmt_hname {
    padding-left: 5px;
  }
  .MS_cmt_list_box .MS_cmt_content {
    padding-left: 15px;
  }
  .MS_cmt_list_box .comment_depth2 {
    padding-left: 10px;
  }
  .MS_cmt_list_box .comment_depth3 {
    padding-left: 15px;
  }
  #comment_password {
    width: 250px;
    left: 7px;
    box-shadow: 0 0 5px 0 #808080;
  }
  #comment_password input[type='password'] {
    width: 75%;
  }
  #comment_password form {
    height: auto !important;
  }
  #comment_password form span {
    display: block;
  }

  /* 답글 */
  .list_board ul li .reply_depth1 .rating,
  .list_board ul li .reply_depth1 .info,
  .list_board ul li .reply_depth2 .rating,
  .list_board ul li .reply_depth2 .info,
  .list_board ul li .reply_depth3 .rating,
  .list_board ul li .reply_depth3 .info {
    padding-left: 12px;
  }
  .list_board ul li .reply_status {
    font-size: 0.875em;
    color: #777777;
    font-weight: normal;
  }
  .list_board .reply_depth1 {
    padding-left: 9%;
  }

  /* 비번입력 */
  .list_board input[type='password'] {
    width: 80%;
    border-right: 0;
    box-sizing: border-box;
    height: 35px;
  }

  .list_board input[type='button'] {
    width: 20%;
    float: right;
    height: 35px;
    background-color: #444;
    color: #fff;
    border: 1px solid #444;
    box-sizing: border-box;
  }

  /* new, hit 아이콘 */
  .list_board ul li dl h4 .new {
    display: inline-block;
    height: 15px;
    line-height: 15px;
    color: red;
    font-size: 11px;
    text-align: center;
    font-weight: 600;
  }
  .list_board ul li dl h4 .hit {
    display: inline-block;
    height: 15px;
    line-height: 15px;
    color: blue;
    font-size: 11px;
    text-align: center;
    font-weight: 600;
  }

  /* 수정,삭제버튼 */
  .list_board ul li .cont_wrap .comment_modify {
    text-align: right;
    margin-top: 5px;
  }
  .list_board ul li .cont_wrap .comment_modify a {
    width: 45px;
    border: 1px solid #444;
    border-radius: 3px;
    font-size: 0.875em;
    display: inline-block;
    text-align: center;
    line-height: 20px;
    height: 20px;
    background-color: #fff;
  }
  .list_board ul li dl .info .review_del {
    width: 45px;
    border: 1px solid #444;
    border-radius: 3px;
    font-size: 0.875em;
    display: inline-block;
    text-align: center;
    line-height: 20px;
    height: 20px;
    background-color: #fff;
  }

  /* 페이지네이션 */
  .paging {
    position: relative;
    text-align: center;
    margin-top: 15px;
  }
  .paging a.next,
  .paging a.prev {
    display: inline-block;
    width: 30px;
    height: 25px;
    line-height: 23px;
    color: #000;
  }
  .paging strong {
    font-weight: bold;
    color: #000;
    text-align: center;
    display: inline-block;
    width: 25px;
    height: 25px;
    line-height: 23px;
    border: 1px solid #111;
    font-size: 0.75em;
    background-color: #fff;
    margin: 0 2px;
  }
  .paging a {
    position: relative;
    display: inline-block;
    width: 30px;
    height: 25px;
    margin: 0px 4px;
    border: none;
    background: none;
    font-weight: normal;
    color: #333333;
    font-size: 12px;
    line-height: 25px;
  }
  .paging .now {
    color: #000;
    font-weight: bold;
  }
  .paging .now:after {
    position: absolute;
    bottom: 0px;
    left: 50%;
    width: 8px;
    height: 1px;
    margin-left: -4px;
    background: #333;
    content: '';
  }

  /* 상세 슬라이드 이미지 */
  .slide-cont1 {
    margin-bottom: 50px !important;
  }
  .slide-cont1 .swiper-wrapper {
    padding-bottom: 20px;
  }
  .slide-cont1 .swiper-pagination {
    bottom: 0 !important;
  }
  .slide-cont1 .swiper-pagination-bullet {
    margin: 0 6px !important;
  }
  .slide-cont1 .swiper-pagination-bullet-active {
    background: #000;
  }
  .slide-cont1 .swiper-button-next {
    background-image: url(https://www.xexymix.com/design/xexymix/image/list_best_next.png);
    background-size: contain;
    right: 3%;
    left: auto;
    width: 16px;
  }
  .slide-cont1 .swiper-button-prev {
    background-image: url(https://www.xexymix.com/design/xexymix/image/list_best_prev.png);
    background-size: contain;
    left: 3%;
    right: auto;
    width: 16px;
  }

  .slide-cont2 {
    padding-bottom: 15px !important;
    margin-bottom: 100px !important;
  }
  .slide-cont2 .swiper-wrapper {
    padding-bottom: 20px;
  }
  .slide-cont2 .swiper-pagination {
    bottom: 0 !important;
  }
  .slide-cont2 .swiper-pagination-bullet {
    margin: 0 6px !important;
  }
  .slide-cont2 .swiper-pagination-bullet-active {
    background: #000;
  }
  .slide-cont2 .swiper-button-next {
    background-image: url(https://www.xexymix.com/design/xexymix/image/list_best_next.png);
    background-size: contain;
    right: 3%;
    left: auto;
    width: 16px;
  }
  .slide-cont2 .swiper-button-prev {
    background-image: url(https://www.xexymix.com/design/xexymix/image/list_best_prev.png);
    background-size: contain;
    left: 3%;
    right: auto;
    width: 16px;
  }

  /* 1+1슬라이드 */
  #oneplus {
    width: 100%;
    text-align: center;
    margin: 75px 0;
  }
  .color-tit {
    font-size: 30px;
    font-weight: 900;
  }
  .color-tit-s {
    padding-bottom: 20px;
  }
  .color-tab {
    margin: 0 3%;
    overflow: hidden;
    text-align: center;
  }
  .color-tab li {
    display: inline-block;
    position: relative;
    overflow: hidden;
    margin: 2px;
    text-align: center;
    text-decoration: none;
    width: 25px;
    height: 25px;
    border-radius: 20px;
    transition: 0.3s;
  }
  .color-tab li .checkP,
  .tabcont .c-name .c-chip .checkP {
    width: 50%;
    height: 100%;
    display: block;
  }
  .color-tab .sub-txt {
    font-size: 16px;
    font-weight: 600;
    padding: 20px 0 10px;
  }
  .color-tab li.current {
    border: 3px solid #ff6d44;
    box-sizing: border-box;
  }
  .tabcont.current {
    display: block;
  }
  .tabcont .c-name {
    padding: 15px 4%;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
  }
  .tabcont .c-name .c-chip {
    position: relative;
    overflow: hidden;
    width: 19px;
    height: 19px;
    border-radius: 20px;
    display: inline-block;
    vertical-align: text-top;
  }
  .color-container {
    padding-bottom: 25px;
  }
  .color-container .swiper-slide {
    padding: 0 1%;
    box-sizing: border-box;
  }
  .color-container .swiper-pagination {
    bottom: 0px;
  }
  .color-container .swiper-pagination-bullet-active {
    background: #000;
  }
  .color-container .swiper-button-next {
    background-image: url(https://www.xexymix.com/design/xexymix/image/list_best_next.png);
    background-size: contain;
    right: 3%;
    left: auto;
    width: 15px;
  }
  .color-container .swiper-button-prev {
    background-image: url(https://www.xexymix.com/design/xexymix/image/list_best_prev.png);
    background-size: contain;
    left: 3%;
    right: auto;
    width: 15px;
  }

  .color-tab2 {
    margin: 0 3%;
    overflow: hidden;
    text-align: center;
  }
  .color-tab2 li {
    display: inline-block;
    margin: 2px;
    text-align: center;
    text-decoration: none;
    width: 25px;
    height: 25px;
    border-radius: 20px;
    transition: 0.3s;
  }
  .tabcont2 {
    display: none;
  }
  .color-tab2 li.current {
    border: 3px solid #ff6d44;
    box-sizing: border-box;
  }
  .tabcont2.current {
    display: block;
  }
  .tabcont2 .c-name {
    padding: 15px 4%;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
  }
  .tabcont2 .c-name .c-chip {
    width: 19px;
    height: 19px;
    border-radius: 20px;
    display: inline-block;
    vertical-align: text-top;
  }
  .color-container2 {
    padding-bottom: 25px;
  }
  .color-container2 .swiper-slide {
    padding: 0 1%;
    box-sizing: border-box;
  }
  .color-container2 .swiper-pagination {
    bottom: 0px;
  }
  .color-container2 .swiper-pagination-bullet-active {
    background: #000;
  }
  .color-container2 .swiper-button-next {
    background-image: url(https://www.xexymix.com/design/xexymix/image/list_best_next.png);
    background-size: contain;
    right: 3%;
    left: auto;
    width: 15px;
  }
  .color-container2 .swiper-button-prev {
    background-image: url(https://www.xexymix.com/design/xexymix/image/list_best_prev.png);
    background-size: contain;
    left: 3%;
    right: auto;
    width: 15px;
  }

  /* 흐르는슬라이드_상단공통 */
  .top-wrap {
    position: relative;
    width: 100%;
  }
  .top-wrap .top-slide ul li img {
    width: 100%;
    height: 100%;
  }
  .top-wrap .top-slide .swiper-wrapper {
    transition-timing-function: linear;
  }

  /* 흐르는슬라이드_워터 */
  .water-wrap {
    position: relative;
    width: 100%;
  }
  .water-wrap .txt-img {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .water-wrap .water-slide ul li img {
    width: 100%;
    height: 100%;
  }
  .water-wrap .water-slide .swiper-wrapper {
    transition-timing-function: linear;
  }

  /* 흐르는슬라이드_이너웨어 */
  .inner-wrap {
    position: relative;
    width: 100%;
  }
  .inner-wrap .inner-slide ul li img {
    width: 100%;
    height: 100%;
  }
  .inner-wrap .inner-slide .swiper-wrapper {
    transition-timing-function: linear;
    overflow: visible !important;
  }

  /*슬리밍젤*/
  .sliming-slide {
    width: 80%;
    margin: auto;
  }
  .sliming-slide-wrap {
    background: #f8f8f8;
    width: 100%;
    margin: auto;
  }
  .sliming-slide-wrap .img-shadow {
    position: relative;
  }
  .sliming-slide-wrap .img-shadow:before {
    content: '';
  }
  .sliming-slide-wrap .swiper-wrapper {
  }

  /* 모델정보 */
  .model_guide {
    padding-bottom: 50px;
  }
  .model_guide .model_tit {
    position: relative;
    border: 2px solid #000;
    margin: 0 14px 20px 14px;
    padding-right: 15px;
    color: #000;
    font-size: 16px;
    text-align: center;
    height: 45px;
    line-height: 45px;
    font-weight: 500;
  }
  .model_guide .model_tit:after {
    content: '';
    position: absolute;
    top: 7px;
    background: url(//xexymix.jpg3.kr/xexymix/2020m/sub/detail/color_btn_icon.png) no-repeat;
    background-size: cover;
    width: 30px;
    height: 30px;
  }
  .model_guide .model_tit.on:after {
    transform: rotate(180deg);
  }
  .model_guide .model_cont {
    padding: 0 14px;
    margin-bottom: 5px;
    display: none;
  }
  .model_guide .model_cont ul {
    overflow: hidden;
  }
  .model_guide .model_cont li {
    float: left;
    width: 33.3%;
  }

  .prd-detail img {
    max-width: 100% !important;
    height: auto !important;
  }
  .headerFixed .cate-header {
    display: none;
  }

  #nhn_btn > div {
    width: 100% !important;
  }
  #basketpage > div.fixed-btn > div.layer-confirm > div.txt {
    padding: 20px 15px !important;
    background-image: none !important;
  }

  /* 스마트픽업 */
  #layerShopChoice {
    z-index: 998 !important;
  }
  #layerShopChoice .layer {
    width: 100%;
    min-height: 100%;
    z-index: 3;
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.65);
  }
  #layerShopChoice .layer .layer-pop {
    position: absolute;
    left: 5%;
    top: 20%;
    z-index: 101;
    width: 90%;
    min-height: auto;
    background-color: #fff;
    display: block;
  }
  #layerShopChoice .layer .layer-pop h3 {
    padding: 0;
    margin: 0 15px;
    color: #000;
    background-color: #fff;
    font-size: 0px;
    height: 50px;
    line-height: 50px;
    font-weight: 600;
    border-bottom: 1px solid #dfdfdf;
  }
  #layerShopChoice .layer .layer-pop h3:before {
    content: '오프라인 실시간 재고확인';
    font-size: 18px;
  }
  #layerShopChoice .layer .layer-pop .layer-close {
    top: 12px;
  }
  #layerShopChoice .layer .layer-pop .layer-close .fa-times {
    width: 25px;
    height: 25px;
    background: url(https://xexymix.jpg3.kr/xexymix/mobile/img/header/drawer-close-btn.png) no-repeat center;
    background-size: cover;
  }
  #layerShopChoice .layer .layer-pop .layer-close .fa-times:before {
    content: ' ';
  }
  #layerShopChoice .layer .layer-pop .shop-info-tb {
    margin: 15px;
    font-size: 13px;
    word-break: keep-all;
  }
  #layerShopChoice .layer .layer-pop .shop-info-tb colgroup col:first-child {
    width: 25%;
  }
  #layerShopChoice .layer .layer-pop .shop-info-tb th {
    border: 0;
    font-weight: 500;
    background-color: #fff;
    text-align: left;
    font-size: 14px;
    vertical-align: top;
  }
  #layerShopChoice .layer .layer-pop .shop-info-tb th div {
    padding: 0;
  }
  #layerShopChoice .layer .layer-pop .shop-info-tb tr:first-child th div {
    line-height: 30px;
    font-size: 0px;
  }
  #layerShopChoice .layer .layer-pop .shop-info-tb tr:first-child th div:before {
    content: '픽업 매장';
    font-size: 14px;
  }
  #layerShopChoice .layer .layer-pop .shop-info-tb td {
    border: 0;
  }
  #layerShopChoice .layer .layer-pop .shop-info-tb td div {
    padding: 0 0 25px;
  }
  #layerShopChoice .layer .layer-pop .shop-info-tb td div ul.store-info {
    color: #888;
  }
  #layerShopChoice .layer .layer-pop .shop-info-tb td div ul.store-info li {
    margin-bottom: 9px;
  }
  #layerShopChoice .layer .layer-pop .shop-info-tb td div ul.store-info li:first-child {
    color: #000;
  }
  #layerShopChoice .layer .layer-pop .shop-info-tb td div ul.store-info li:last-child {
    margin-bottom: 0;
  }
  #layerShopChoice .layer .layer-pop .shop-info-tb select {
    height: 30px;
    border: 1px solid #999;
    font-size: 13px;
  }
  #layerShopChoice .layer .layer-pop .shop-info-tb .smartpickup-comment {
    border-top: 1px solid #dfdfdf;
    padding-top: 10px;
  }

  /* 선물하기 */
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .buy_on a.gift {
    align-items: center;
    justify-content: center;
    padding: 15px 0;
    width: 100%;
    color: #000;
    background: #fff;
    border: 1px solid #000;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .buy_on a.gift .fa-gift {
    margin-top: -2px;
    margin-right: 3px;
    font-size: 16px;
  }
  /* 선물하기 상품옵션 */
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailButton .shopdetailButtonTop a.gift {
    align-items: center;
    justify-content: center;
    padding: 15px 0;
    width: 100%;
    background: #fff;
    border: 1px solid #000;
    color: #000;
  }
  .shopdetail .shopdetailInfo .shopdetailInfoBottom .shopdetailButton .shopdetailButtonTop a.gift .fa-gift {
    margin-top: -2px;
    margin-right: 3px;
    font-size: 16px;
  }

  /* BASIC css end */

  /* �곸꽭�섏씠吏� */

  .detail_st .com {
    text-align: center;
    padding: 50px 0;
    color: #111;
    word-break: break-all;
  }
  .detail_st .tit {
    padding-bottom: 30px;
    font-size: 18px;
    font-weight: 700;
  }
  .detail_st .tit_s {
    padding-bottom: 15px;
    border-bottom: 1px solid #999;
    font-size: 14px;
    font-weight: 500;
    text-align: left;
  }
  .detail_st .tit_big {
    padding-bottom: 30px;
    font-size: 45px;
    font-weight: 700;
  }
  .detail_st .txt {
    padding-left: 10%;
    padding-right: 10%;
    text-align: left;
    font-size: 14px;
    line-height: 24px;
    word-break: keep-all;
  }
  .detail_st .txt_center {
    padding: 0 10%;
    text-align: center;
    font-size: 14px;
    line-height: 24px;
    word-break: keep-all;
  }
  .detail_st .txt2 {
    padding-left: 10%;
    padding-right: 10%;
    text-align: left;
    font-size: 14px;
    line-height: 24px;
    word-break: keep-all;
  }
  .detail_st .model {
    font-size: 14px;
    line-height: 24px;
  }
  .detail_st .model_2 {
    font-size: 13px;
    margin-bottom: 20px;
  }
  .detail_st .model_2 li {
    display: inline-block;
    width: 40%;
    line-height: 15px;
    padding: 0 4%;
    vertical-align: top;
  }
  .detail_st .model_2 li img {
    width: 96%;
  }
  .detail_st .name {
    padding: 10px 0;
    font-weight: 600;
    font-size: 15px;
  }

  .detail_st .model_size {
    width: 100%;
    text-align: center;
  }
  .detail_st .model_size ul {
    overflow: hidden;
  }
  .detail_st .model_size li {
    position: relative;
    display: inline-block;
    padding-bottom: 50px;
  }
  .detail_st .model_size .m_img {
    float: left;
    width: 50%;
  }
  .detail_st .model_size .m_img img {
    width: 90%;
  }
  .detail_st .model_size .m_img .name {
    display: block;
    font-size: 15px;
    font-weight: 600;
  }
  .detail_st .model_size .m_spec {
    float: left;
    width: 45%;
    padding-left: 5%;
    font-size: 12px;
    line-height: 20px;
    text-align: left;
  }
  .detail_st .model_size .m_spec .tit {
    font-size: 15px;
    font-weight: 600;
    padding-bottom: 10px;
    display: inline-block;
  }
  .detail_st .model_size .m_spec .fit {
    font-weight: 600;
  }

  .detail_st .color {
    padding-bottom: 20px;
  }
  .detail_st .color a {
    padding: 0 3px;
    display: inline-block;
  }
  .detail_st .color a img {
    width: 100px;
    margin-bottom: 20px;
  }
  .detail_st .color > img {
    width: 30%;
    margin-bottom: 15px;
  }
  .detail_st .ps {
    padding: 30px 10%;
    font-size: 14px;
    line-height: 24px;
    text-align: left;
  }
  .detail_st .image {
    padding-bottom: 50px;
  }
  .detail_st .image img {
    width: 100%;
  }
  .detail_st .image ul {
    overflow: hidden;
  }
  .detail_st .image li {
    width: 50%;
    float: left;
  }
  .detail_st .image4 {
    font-size: 0;
  }
  .detail_st .image4 ul {
    overflow: hidden;
  }
  .detail_st .image4 li {
    width: 25%;
    display: inline-block;
  }
  .detail_st .image4 li img {
    width: 100%;
  }
  .detail_st .plan {
    padding-bottom: 50px;
  }
  .detail_st .plan img {
    width: 100%;
    display: block;
    float: left;
  }
  .detail_st b {
    color: #111 !important;
  }

  .gray_bg {
    background: #f4f4f4;
    padding: 30px 0px;
  }

  .media {
    width: 80%;
    margin: 0 auto;
  }
  .media .youtubeWrap {
    position: relative;
    width: 100%;
    padding-bottom: 100%;
  }
  .media .youtubeWrap iframe {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .media_w {
    width: 100%;
    margin: 0 auto;
  }
  .media_w .youtubeWrap {
    position: relative;
    width: 100%;
    padding-bottom: 56%;
  }
  .media_w .youtubeWrap iframe {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .size_table {
    width: 94%;
    margin: 0 3% 50px 3%;
    border-top: 1px solid #999;
  }
  .size_table ul li {
    border-bottom: 1px solid #d1d1d1;
    height: 42px;
    line-height: 42px;
    list-style: none;
    font-size: 12px;
    font-weight: 300;
  }
  .size_table ul li b {
    font-weight: 400;
  }
  .size_table ul li .b700 {
    font-weight: 500;
  }
  .size_table ul li span {
    border-left: 1px solid #d1d1d1;
    display: inline-block;
  }
  .size_table ul li span:first-child {
    border-left: 0px;
    width: 22.5%;
  }
  .size_table p {
    text-align: right;
    color: #666;
    font-size: 11px;
    padding-top: 10px;
  }
  .size_table .width_1 {
    text-align: left;
  }
  .size_table .width_1 li {
    height: auto;
  }
  .size_table .width_1 li:first-child {
    line-height: 25px;
  }
  .size_table .width_1 li:first-child {
    line-height: 25px;
  }
  .size_table .width_1 li span:first-child {
    width: 29.5%;
  }
  .size_table .width_1 li span {
    padding: 0 3%;
  }
  .size_table .width_3 li span {
    width: 24.7%;
    margin-right: -1%;
  }
  .size_table .width_4 li span {
    width: 19.2%;
    margin-right: -1%;
  }
  .size_table .width_5 li span {
    width: 16.4%;
    margin-right: -1%;
  }
  .size_table .width_6 li span {
    width: 13.3%;
    margin-right: -1%;
  }
  .size_table .width_6 li span:first-child {
    width: 17.2%;
    letter-spacing: -1px;
  }
  .size_table .bg_gray {
    background: #f6f6f6;
  }

  .guide_table {
    width: 94%;
    margin: 0 3% 50px 3%;
    text-align: left;
    word-break: keep-all;
  }
  .guide_table ul {
    background: #f6f6f6;
    overflow: hidden;
    border-bottom: 1px solid #d1d1d1;
  }
  .guide_table ul li:last-child {
    background: #fff;
  }
  .guide_table ul li {
    float: left;
    width: 63%;
    padding: 13px 3% 14px 3%;
    line-height: 18px;
    list-style: none;
    font-size: 12px;
    font-weight: 300;
  }
  .guide_table ul li:first-child {
    background: #f6f6f6;
    border-left: 0px;
    width: 25%;
    font-weight: 400;
  }
  .guide_table .h32 {
    height: 32px;
    line-height: 32px;
  }
  .guide_table .p20 {
    padding-right: 20% !important;
  }

  .bl_scroll_1 {
    overflow-x: scroll;
    width: 100%;
    height: auto;
    margin: 0 auto;
    white-space: nowrap;
  }
  .bl_scroll_1 li {
    display: inline-block;
    width: 33%;
  }
  .bl_scroll_1 li img {
    width: 100%;
    padding-bottom: 15px;
  }
  .bl_scroll_2 {
    overflow-x: scroll;
    width: 100%;
    height: auto;
    margin: 0 auto;
    white-space: nowrap;
    margin-top: 15px;
  }
  .bl_scroll_2 li {
    display: inline-block;
    width: 33%;
  }
  .bl_scroll_2 li img {
    width: 100%;
    padding-bottom: 15px;
  }

  .cont_divide {
    width: 100%;
    overflow: hidden;
  }
  .cont_divide .d_left {
    float: left;
    width: 50%;
  }
  .cont_divide .d_right {
    float: right;
    width: 50%;
  }

  .cont_divide2 {
    width: 100%;
    overflow: hidden;
  }
  .cont_divide2 .d_left {
    float: left;
    width: 49%;
  }
  .cont_divide2 .d_right {
    float: right;
    width: 49%;
  }

  .cont_divide3 {
    width: 100%;
    overflow: hidden;
  }
  .cont_divide3 .d_left {
    float: left;
  }
  .cont_divide3 .d_right {
    float: right;
  }

  .pdb10 {
    padding-bottom: 10px;
  }
  .pdb15 {
    padding-bottom: 15px;
  }
  .pdb20 {
    padding-bottom: 20px;
  }
  .pdb25 {
    padding-bottom: 25px;
  }
  .pdb30 {
    padding-bottom: 30px;
  }
  .pdb35 {
    padding-bottom: 35px;
  }
  .pdb40 {
    padding-bottom: 40px;
  }
  .pdb45 {
    padding-bottom: 45px;
  }
  .pdb50 {
    padding-bottom: 50px;
  }
  .pdb75 {
    padding-bottom: 75px;
  }
  .pdb100 {
    padding-bottom: 100px;
  }
  .pdb125 {
    padding-bottom: 125px;
  }
  .pdb150 {
    padding-bottom: 150px;
  }
  .pdb175 {
    padding-bottom: 175px;
  }
  .pdb200 {
    padding-bottom: 200px;
  }
  .pdb250 {
    padding-bottom: 250px;
  }
  .pdb300 {
    padding-bottom: 300px;
  }
  .pdb350 {
    padding-bottom: 350px;
  }
  .pdb400 {
    padding-bottom: 400px;
  }

  .pdr5 {
    padding-right: 1%;
  }
  .pdl5 {
    padding-left: 1%;
  }
  .pdr10 {
    padding-right: 2%;
  }
  .pdl10 {
    padding-left: 2%;
  }

  .line1000 {
    width: 80%;
    height: 1px;
    background: #dfdfdf;
    margin: 15px auto;
  }

  .txt-box {
    overflow: hidden;
    padding-bottom: 20px;
  }

  .color-name {
    padding: 15px 4%;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
  }
  .color-name .color-chip {
    width: 19px;
    height: 19px;
    border-radius: 20px;
    display: inline-block;
    vertical-align: text-top;
  }

  .option_tit {
    padding: 100px 0 50px;
    font-size: 24px;
    text-align: center;
    letter-spacing: -1px;
  }
  .option_tit p {
    padding-bottom: 15px;
    font-size: 35px;
    font-weight: 700;
  }

  .detail_tit {
  }
  .detail_tit ul {
    overflow: hidden;
  }
  .detail_tit li {
    display: inline-block;
    width: 40%;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
  }

  .x_brapad {
    position: relative;
    height: 150px;
    text-align: left;
    margin: 0 5% 100px 5%;
    border: 1px solid #e5e5e5;
  }
  .x_brapad > img {
    width: 33%;
    padding-top: 10%;
  }
  .x_brapad .tbox {
    position: absolute;
    top: 20%;
    left: 38%;
    word-break: keep-all;
  }
  .x_brapad .tbox .t1 {
    font-size: 18px;
    font-weight: 600;
    padding-bottom: 15px;
  }
  .x_brapad .tbox .t2 {
    font-size: 13px;
    width: 86%;
    letter-spacing: -1px;
  }

  /*�곸꽭湲고쉷*/
  .project_wrap {
    width: 100%;
    margin: 0 auto;
    color: #000;
    text-align: left;
    word-break: keep-all;
  }
  .project_wrap .main_tit {
    position: relative;
    width: 100%;
  }
  .project_wrap .main_txt {
    padding: 50px 6%;
    color: #fff;
    background: #1c1c1c;
  }

  .project_wrap .type_A {
    position: relative;
    color: #fff;
  }
  .project_wrap .type_A .txtBox {
    position: absolute;
    left: 0;
    bottom: 0;
    width: -webkit-fill-available;
  }
  .project_wrap .type_A .txtBox2 {
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translateY(-50%);
  }
  .project_wrap .type_B {
    position: relative;
    color: #000;
  }
  .project_wrap .type_B .imgSb {
    position: relative;
    width: 100%;
  }
  .project_wrap .type_B .imgSb span {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 16px;
    padding: 8px 14px;
    background: #000;
    color: #fff;
  }
  .project_wrap .type_c {
    position: relative;
  }
  .project_wrap .type_c > div {
    display: inline-block;
    position: relative;
    width: 50%;
    text-align: center;
    vertical-align: top;
    margin-right: -2px;
    margin-top: 1px;
  }

  .project_wrap .imgCut {
    position: relative;
  }
  .project_wrap .imgCut:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 70%;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.5));
  }
  .project_wrap .txtBox {
    padding: 35px 6%;
  }
  .project_wrap .txtBoxLF {
    padding: 0 6%;
  }
  .project_wrap .txtTop {
    padding: 100px 6% 0;
  }
  .project_wrap .colorName {
    position: relative;
    padding-top: 5px;
    margin-top: 25px;
    font-size: 16px;
    font-weight: 600;
  }
  .project_wrap .colorName:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 15px;
    height: 2px;
    background: #fff;
  }

  .project_wrap .txt01 {
    font-size: 33px;
    line-height: 45px;
    letter-spacing: -2px;
  }
  .project_wrap .txt02 {
    font-size: 30px;
    line-height: 40px;
    letter-spacing: -2px;
  }
  .project_wrap .txt03 {
    font-size: 21px;
    line-height: 30px;
    letter-spacing: -1px;
  }
  .project_wrap .txt04 {
    font-size: 18px;
    line-height: 25px;
    letter-spacing: -1px;
  }
  .project_wrap .txt05 {
    font-size: 16px;
    line-height: 23px;
    letter-spacing: -1px;
  }
  .project_wrap .txt06 {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -1px;
  }
  .project_wrap .txt06 {
    font-size: 12px;
    line-height: 18px;
    letter-spacing: -1px;
  }
  .project_wrap .line_tit {
    position: relative;
    display: inline-block;
    font-size: 18px;
    font-weight: 600;
    margin: 60px 25px 50px;
    padding-bottom: 6px;
  }
  .project_wrap .line_tit:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 3px;
    background: #000;
  }
  .project_wrap .divline {
    margin: 25px 0;
    width: 100%;
    height: 1px;
    background: #000;
  }
  .project_wrap .top_tit {
    text-align: center;
  }

  .project_wrap .type_step {
    position: relative;
    text-align: left;
    margin-bottom: 3px;
  }
  .project_wrap .type_step .txt_l {
    display: inline-block;
    width: 38%;
    vertical-align: top;
    margin-right: -2px;
    word-break: keep-all;
    padding: 0 6%;
  }
  .project_wrap .type_step .txt_l span {
    display: inherit;
    padding: 5px 12px;
    margin-bottom: 15px;
    background: #d6d6d6;
    font-size: 17px;
    font-weight: 600;
  }
  .project_wrap .type_step .img_r {
    display: inline-block;
    width: 50%;
    vertical-align: top;
    margin-right: -2px;
    word-break: keep-all;
  }

  .project_wrap .txtGuide {
    padding: 0 6%;
  }
  .project_wrap .txtGuide li {
    list-style-type: circle;
    margin-left: 3%;
    margin-bottom: 5px;
  }

  .list_check li {
    position: relative;
    margin-bottom: 10px;
    padding-left: 30px;
  }
  .list_check li:before {
    content: '';
    position: absolute;
    top: 2px;
    left: 0;
    width: 19px;
    height: 19px;
    background: url(//xexymix.jpg3.kr/xexymix/img/icon_check.png) no-repeat;
    background-size: cover;
  }

  .sbBox {
    display: inline-block;
    position: relative;
    width: 42%;
    text-align: center;
    vertical-align: top;
    margin-right: -2px;
    padding: 30px 4% 0;
    word-break: keep-all;
  }
  .sbBox .imgSb {
    padding-bottom: 15px;
    width: 60%;
    margin: 0 auto;
  }
  .sbBox2 {
    display: inline-block;
    position: relative;
    width: 50%;
    text-align: center;
    vertical-align: top;
    margin-right: -2px;
    word-break: keep-all;
  }
  .sbBox2 .imgSb {
    padding-bottom: 15px;
  }
  .sbBox2b {
    display: inline-block;
    position: relative;
    width: 48%;
    text-align: center;
    vertical-align: top;
    margin-right: -2px;
    word-break: keep-all;
  }
  .sbBox2b:first-child {
    margin-right: 3.6%;
  }
  .sbBox2b .imgSb {
    padding-bottom: 15px;
  }
  .sbBox3 {
    display: inline-block;
    position: relative;
    width: 29%;
    text-align: center;
    vertical-align: top;
    margin-right: -2px;
    padding: 0 2%;
    word-break: keep-all;
  }
  .sbBox3 .imgSb {
    padding-bottom: 15px;
    width: 75%;
    margin: 0 auto;
  }
  .sbBox3b {
    display: inline-block;
    position: relative;
    width: 33.33%;
    text-align: center;
    vertical-align: top;
    margin-right: -0.8%;
    word-break: keep-all;
  }
  .sbBox3b .imgSb {
    padding-bottom: 15px;
    width: 75%;
    margin: 0 auto;
  }
  .sbBox4 {
    display: inline-block;
    position: relative;
    width: 20.8%;
    text-align: center;
    vertical-align: top;
    margin-right: -0.5%;
    padding: 0 2%;
    word-break: keep-all;
  }
  .sbBox4 .imgSb {
    padding-bottom: 15px;
  }
  .sbBox6 {
    display: inline-block;
    position: relative;
    width: 25%;
    text-align: center;
    vertical-align: top;
    margin-right: -0.5%;
    padding: 0 3%;
    word-break: keep-all;
  }
  .sbBox6 .imgSb {
    padding: 5px 5px 10px 5px;
  }

  .brand_video {
    width: 80%;
    margin: 0 auto;
    border: 12px solid #f3f3f3;
  }
  .brand_video video {
    margin-bottom: -3px;
  }
  .top-slide .swiper-slide {
    width: 50% !important;
  }

  .prod_video {
    position: relative;
    display: flex;
  }
  .prod_video .tit_txt {
    position: relative;
    width: 50%;
  }
  .prod_video .tit_txt > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -54%);
  }
  .prod_video .tit_txt > div p:nth-child(1) {
    margin-bottom: 40px;
  }
  .prod_video .tit_txt > div p:nth-child(1) img {
    width: 125px;
  }
  .prod_video .tit_txt > div p:nth-child(2) {
    font-size: 20px;
    font-weight: 900;
  }
  .prod_video .tit_txt > div p:nth-child(2):before {
    content: '';
    position: absolute;
    top: 66px;
    width: 22px;
    height: 3px;
    background: #000;
  }
  .prod_video .tit_txt2 {
    position: relative;
    width: 50%;
  }
  .prod_video .tit_txt2 > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -54%);
  }
  .prod_video .tit_txt2 > div p {
    padding-top: 10px;
    font-size: 20px;
    font-weight: 900;
  }
  .prod_video .tit_txt2 > div p:before {
    content: '';
    position: absolute;
    top: 0;
    width: 22px;
    height: 3px;
    background: #000;
  }
  .prod_video video {
    width: 45%;
    border: 12px solid #f3f3f3;
  }
  .prod_video iframe {
    width: 45%;
    border: 12px solid #f3f3f3;
  }

  .prod_video_bg {
    position: relative;
    display: flex;
  }
  .prod_video_bg .tit_txt {
    position: relative;
    width: 50%;
  }
  .prod_video_bg .tit_txt > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-44%, -54%);
  }
  .prod_video_bg video {
    width: 45% !important;
    border: 12px solid transparent;
  }
  .prod_video_bg iframe {
    width: 45% !important;
    border: 12px solid transparent;
  }

  .prod_iframe iframe {
    margin-bottom: -3px;
  }

  .bg_gray {
    background: #f3f3f3;
  }
  .bg_kids {
    background: #fffeee;
  }
  .bg_golf {
    background: #f8f8f8;
  }

  .pro_cut {
    text-align: center;
  }
  .pro_cut > div {
    position: relative;
    width: 80%;
    margin: 0 auto;
  }
  .pro_cut > div > span {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    font-size: 16px;
    font-weight: 600;
  }

  .pro-photo > div {
    position: relative;
    width: 80%;
    margin: 0 auto;
  }
  .pro-photo > div img {
    position: relative;
    width: 100%;
  }
  .pro-photo > div:after {
    position: absolute;
    top: 7%;
    left: 0;
    width: 100%;
    font-size: 16px;
    font-weight: 600;
  }
  .pro-photo > div:nth-child(1):after {
    content: 'FRONT';
  }
  .pro-photo > div:nth-child(2):after {
    content: 'BACK';
  }
  .pro-photo > div img {
    width: 100%;
  }

  .guideBox {
    overflow: hidden;
    padding-bottom: 25px;
  }
  .guideBox .imgLeft {
    float: left;
    width: 38%;
    margin-right: 6%;
  }
  .guideBox .txtRight {
    float: left;
    width: 52%;
    padding-top: 10px;
    word-break: keep-all;
  }

  .listBox {
    overflow: hidden;
    padding-bottom: 25px;
    margin-bottom: 25px;
    border-bottom: 1px solid #e1e1e1;
  }
  .listBox .imgLeft {
    float: left;
    width: 25%;
    margin-right: 5%;
  }
  .listBox .txtRight {
    float: left;
    width: 70%;
    word-break: keep-all;
  }

  .btn_more {
    display: block;
    position: relative;
    width: auto;
    height: 40px;
    line-height: 40px;
    margin: 0 auto;
    background: #000;
    color: #fff;
    text-align: center;
    font-size: 17px;
    padding-right: 20px;
  }
  .btn_more:after {
    content: '';
    position: absolute;
    top: 12px;
    width: 10px;
    height: 15px;
    margin-left: 15px;
    background: url(https://xexymix.jpg3.kr/xexymix/img/btn_more.png) no-repeat;
    background-size: cover;
  }
  .btn_present {
    display: block;
    position: relative;
    width: auto;
    height: 40px;
    line-height: 40px;
    margin: 0 auto;
    background: #e1e1e1;
    color: #000;
    text-align: center;
    font-size: 17px;
  }

  .washBox {
    border: 1px solid #777;
    margin: 20% 5% 10% 5%;
    padding: 5%;
    text-align: left;
    font-size: 12px;
    letter-spacing: -0.7px;
  }

  .wordBox {
    border: 1px solid #777;
    margin: 20% 5% 10% 5%;
    padding: 5%;
    text-align: center;
    font-size: 12px;
    letter-spacing: -0.7px;
  }

  .kcmark {
    position: relative;
    background: #f9f9f9;
    margin: 75px 5%;
    padding: 30px 0 30px 68px;
    border: 1px solid #e9e9e9;
    font-size: 12px;
    text-align: left;
    letter-spacing: -0.7px;
  }
  .kcmark:before {
    content: '';
    position: absolute;
    top: 32px;
    left: 35px;
    width: 32px;
    height: 32px;
    background: url(https://xexymix.jpg3.kr/xexymix/2020/sub/detail/kcmark_logo.png) no-repeat;
    background-size: cover;
  }

  .fw_200 {
    font-weight: 200;
  }
  .fw_300 {
    font-weight: 300;
  }
  .fw_400 {
    font-weight: 400;
  }
  .fw_500 {
    font-weight: 500;
  }
  .fw_600 {
    font-weight: 600;
  }
  .fw_900 {
    font-weight: 900;
  }

  .pb_10 {
    padding-bottom: 3px;
  }
  .pb_15 {
    padding-bottom: 5px;
  }
  .pb_20 {
    padding-bottom: 10px;
  }
  .pb_25 {
    padding-bottom: 15px;
  }
  .pb_30 {
    padding-bottom: 20px;
  }
  .pb_35 {
    padding-bottom: 25px;
  }
  .pb_40 {
    padding-bottom: 30px;
  }
  .pb_45 {
    padding-bottom: 35px;
  }
  .pb_50 {
    padding-bottom: 40px;
  }

  .swiper-wrapper {
    display: flex;
    flex-wrap: wrap;
  }
`;
